import React from 'react';

interface Props {
  className?: string;
}

export const DashBoardIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 18 18" className={props.className || ''}>
    <path
      d="M0 0H8V8H0V0ZM0 10H8V18H0V10ZM10 0H18V8H10V0ZM10 10H18V18H10V10ZM12 2V6H16V2H12ZM12 12V16H16V12H12ZM2 2V6H6V2H2ZM2 12V16H6V12H2Z"
      fill="#666666"
    />
  </svg>
);

export const UsersIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 18 20" className={props.className || ''}>
    <path
      d="M9.00117 0C6.24045 0 4 2.24045 4 5.00118C4 7.7619 6.24045 10.0024 9.00117 10.0024C11.7619 10.0024 14.0023 7.7619 14.0023 5.00118C13.9977 2.24045 11.7619 0 9.00117 0ZM9.00117 8.00095C7.34661 8.00095 6.00141 6.65574 6.00141 5.00118C6.00141 3.34662 7.34661 2.00141 9.00117 2.00141C10.6557 2.00141 12.0009 3.34662 12.0009 5.00118C12.0009 6.65574 10.6557 8.00095 9.00117 8.00095Z"
      fill="#273773"
    />
    <path
      d="M13.0007 11.999H5.00117C2.24045 11.999 0 14.2395 0 17.0002V19.0016C0 19.5547 0.449965 20 0.998359 20H16.9988C17.5519 20 17.9972 19.55 17.9972 19.0016V17.0002C17.9972 14.2395 15.7614 11.999 13.0007 11.999ZM16.0005 17.9986H2.00141V17.0002C2.00141 15.3456 3.34661 14.0004 5.00117 14.0004H13.0007C14.6553 14.0004 16.0005 15.3456 16.0005 17.0002V17.9986Z"
      fill="#273773"
    />
  </svg>
);

export const GroupsIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 20 15" className={props.className || ''}>
    <path
      d="M10.0398 0C7.99359 0 6.33301 1.66059 6.33301 3.70679C6.33301 5.753 7.99359 7.41358 10.0398 7.41358C12.086 7.41358 13.7466 5.753 13.7466 3.70679C13.7466 1.66059 12.086 0 10.0398 0ZM10.0398 5.93017C8.81347 5.93017 7.81642 4.93312 7.81642 3.70679C7.81642 2.48046 8.81347 1.48341 10.0398 1.48341C11.2661 1.48341 12.2632 2.48046 12.2632 3.70679C12.2632 4.93312 11.2661 5.93017 10.0398 5.93017Z"
      fill="#666666"
    />
    <path
      d="M12.2629 8.89355H7.81617C5.76996 8.89355 4.10938 10.5541 4.10938 12.6003V14.0838C4.10938 14.4937 4.44288 14.8237 4.84934 14.8237H15.2263C15.6362 14.8237 15.9662 14.4902 15.9662 14.0838V12.6003C15.9697 10.5541 14.3091 8.89355 12.2629 8.89355ZM14.4863 13.3403H5.59279V12.6003C5.59279 11.374 6.58983 10.377 7.81617 10.377H12.2629C13.4893 10.377 14.4863 11.374 14.4863 12.6003V13.3403Z"
      fill="#666666"
    />
    <path
      d="M14.0703 7.41011V5.9267C15.2966 5.9267 16.2937 4.92965 16.2937 3.70332C16.2937 2.47698 15.2966 1.47994 14.0703 1.47994V0C16.1165 0 17.7771 1.66059 17.7771 3.70679C17.7771 5.753 16.1165 7.41011 14.0703 7.41011Z"
      fill="#666666"
    />
    <path
      d="M20.0003 12.6003V14.0838C20.0003 14.4937 19.6668 14.8237 19.2603 14.8237H17.0369V13.3403H18.5169V12.6003C18.5169 11.374 17.5198 10.377 16.2935 10.377H15.6855V8.89355H16.2935C18.3397 8.89355 20.0003 10.5541 20.0003 12.6003Z"
      fill="#666666"
    />
    <path
      d="M2.22363 3.70679C2.22363 1.66059 3.88422 0 5.93042 0V1.48341C4.70409 1.48341 3.70704 2.48046 3.70704 3.70679C3.70704 4.93312 4.70409 5.93017 5.93042 5.93017V7.41358C3.88422 7.41011 2.22363 5.753 2.22363 3.70679Z"
      fill="#666666"
    />
    <path
      d="M3.70679 8.89355H4.31475V10.377H3.70679C2.48046 10.377 1.48341 11.374 1.48341 12.6003V13.3403H2.96682V14.8237H0.743443C0.333507 14.8237 0 14.4902 0 14.0803V12.5969C0 10.5541 1.66059 8.89355 3.70679 8.89355Z"
      fill="#666666"
    />
  </svg>
);

export const HouseIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 21 19" className={props.className || ''}>
    <path
      d="M17.1818 19H3.81818C3.56502 19 3.32223 18.8981 3.14322 18.7168C2.9642 18.5354 2.86364 18.2895 2.86364 18.033V9.32998H0L9.85759 0.251766C10.0333 0.0897719 10.2624 0 10.5 0C10.7376 0 10.9667 0.0897719 11.1424 0.251766L21 9.32998H18.1364V18.033C18.1364 18.2895 18.0358 18.5354 17.8568 18.7168C17.6778 18.8981 17.435 19 17.1818 19ZM4.77273 17.066H16.2273V7.5478L10.5 2.27377L4.77273 7.5478V17.066Z"
      fill="#666666"
    />
  </svg>
);

export const TemplateIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" className={props.className || ''}>
    <path
      d="M17.8333 9.5H6.16667C5.25 9.5 4.5 8.75 4.5 7.83333V6.16667C4.5 5.25 5.25 4.5 6.16667 4.5H17.8333C18.75 4.5 19.5 5.25 19.5 6.16667V7.83333C19.5 8.75 18.75 9.5 17.8333 9.5ZM6.16667 6.16667V7.83333H17.8333V6.16667H6.16667Z"
      fill="#666666"
    />
    <path
      d="M9.5 19.4993H6.16667C5.25 19.4993 4.5 18.7493 4.5 17.8327V12.8327C4.5 11.916 5.25 11.166 6.16667 11.166H9.5C10.4167 11.166 11.1667 11.916 11.1667 12.8327V17.8327C11.1667 18.7493 10.4167 19.4993 9.5 19.4993ZM6.16667 12.8327V17.8327H9.5V12.8327H6.16667Z"
      fill="#666666"
    />
    <path
      d="M18.6663 12.8327H13.6663C13.1663 12.8327 12.833 12.4993 12.833 11.9993C12.833 11.4993 13.1663 11.166 13.6663 11.166H18.6663C19.1663 11.166 19.4997 11.4993 19.4997 11.9993C19.4997 12.4993 19.1663 12.8327 18.6663 12.8327Z"
      fill="#666666"
    />
    <path
      d="M18.6663 16.1667H13.6663C13.1663 16.1667 12.833 15.8333 12.833 15.3333C12.833 14.8333 13.1663 14.5 13.6663 14.5H18.6663C19.1663 14.5 19.4997 14.8333 19.4997 15.3333C19.4997 15.8333 19.1663 16.1667 18.6663 16.1667Z"
      fill="#666666"
    />
    <path
      d="M18.6663 19.5007H13.6663C13.1663 19.5007 12.833 19.1673 12.833 18.6673C12.833 18.1673 13.1663 17.834 13.6663 17.834H18.6663C19.1663 17.834 19.4997 18.1673 19.4997 18.6673C19.4997 19.1673 19.1663 19.5007 18.6663 19.5007Z"
      fill="#666666"
    />
  </svg>
);

export const OpenCloseToggle: React.FC<Props> = (props) => (
  <svg viewBox="0 0 42 40" fill="none" className={props.className || ''}>
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H42V40H3C1.34315 40 0 38.6569 0 37V3Z"
      fill="#243665"
    />
    <path
      d="M29.2502 25.4999V27.3333H12.7502V25.4999H29.2502ZM16.0465 12.5786L17.3427 13.8748L14.4258 16.7916L17.3427 19.7084L16.0465 21.0046L11.8335 16.7916L16.0465 12.5786ZM29.2502 19.0833V20.9166H21.0002V19.0833H29.2502ZM29.2502 12.6666V14.4999H21.0002V12.6666H29.2502Z"
      fill="white"
    />
  </svg>
);

export const SearchIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" className={props.className || ''}>
    <path
      d="M23.414 20.586L18.337 15.509C19.386 13.928 20 12.035 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C12.035 20 13.928 19.386 15.509 18.337L20.586 23.414C21.366 24.195 22.634 24.195 23.414 23.414C24.195 22.633 24.195 21.367 23.414 20.586ZM3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17C6.14 17 3 13.86 3 10Z"
      fill="#8E8EA1"
    />
  </svg>
);

export const ChatIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 32 32" fill="none" className={props.className || ''}>
    <path
      d="M16.0002 2.66652C13.9592 2.66519 11.9451 3.13246 10.1131 4.0323C8.28118 4.93215 6.68026 6.24056 5.43373 7.85672C4.18721 9.47288 3.32835 11.3536 2.92334 13.3541C2.51834 15.3545 2.57799 17.4212 3.09771 19.395C3.61743 21.3687 4.58334 23.1968 5.92101 24.7384C7.25869 26.28 8.93241 27.4939 10.8132 28.2865C12.694 29.0792 14.7317 29.4295 16.7693 29.3105C18.8068 29.1914 20.7899 28.6062 22.5656 27.5999L27.5789 29.2705C27.7151 29.3135 27.8573 29.3347 28.0002 29.3332C28.2114 29.333 28.4195 29.2827 28.6074 29.1864C28.7953 29.0901 28.9576 28.9505 29.0811 28.7792C29.2045 28.6079 29.2855 28.4097 29.3173 28.2009C29.3491 27.9922 29.3309 27.7789 29.2642 27.5785L27.6002 22.5652C28.7527 20.5378 29.3526 18.2434 29.3399 15.9114C29.3272 13.5794 28.7024 11.2916 27.5279 9.27688C26.3534 7.26218 24.6705 5.59121 22.6475 4.43114C20.6244 3.27107 18.3323 2.66257 16.0002 2.66652ZM24.8709 22.8279L25.8922 25.8945L22.8256 24.8732C22.6385 24.8094 22.4394 24.7882 22.2431 24.8113C22.0468 24.8344 21.8581 24.9011 21.6909 25.0065C19.4671 26.4139 16.8024 26.9518 14.2068 26.5173C11.6112 26.0827 9.267 24.7063 7.62282 22.6514C5.97864 20.5965 5.14997 18.0075 5.2954 15.3798C5.44083 12.7521 6.55016 10.2703 8.41106 8.40937C10.272 6.54846 12.7538 5.43914 15.3815 5.2937C18.0092 5.14827 20.5982 5.97694 22.6531 7.62112C24.708 9.2653 26.0844 11.6095 26.519 14.2051C26.9535 16.8007 26.4156 19.4654 25.0082 21.6892C24.9021 21.8568 24.8346 22.046 24.8109 22.243C24.7871 22.44 24.8076 22.6398 24.8709 22.8279Z"
      fill="#666666"
    />
    <path
      d="M21.333 11.3335H10.6663C10.3127 11.3335 9.97358 11.474 9.72353 11.724C9.47348 11.9741 9.33301 12.3132 9.33301 12.6668C9.33301 13.0205 9.47348 13.3596 9.72353 13.6096C9.97358 13.8597 10.3127 14.0002 10.6663 14.0002H21.333C21.6866 14.0002 22.0258 13.8597 22.2758 13.6096C22.5259 13.3596 22.6663 13.0205 22.6663 12.6668C22.6663 12.3132 22.5259 11.9741 22.2758 11.724C22.0258 11.474 21.6866 11.3335 21.333 11.3335ZM15.9997 18.0002H10.6663C10.3127 18.0002 9.97358 18.1406 9.72353 18.3907C9.47348 18.6407 9.33301 18.9799 9.33301 19.3335C9.33301 19.6871 9.47348 20.0263 9.72353 20.2763C9.97358 20.5264 10.3127 20.6668 10.6663 20.6668H15.9997C16.3533 20.6668 16.6924 20.5264 16.9425 20.2763C17.1925 20.0263 17.333 19.6871 17.333 19.3335C17.333 18.9799 17.1925 18.6407 16.9425 18.3907C16.6924 18.1406 16.3533 18.0002 15.9997 18.0002Z"
      fill="#666666"
    />
  </svg>
);

export const NotifitionIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 32 32" fill="none" className={props.className || ''}>
    <path
      d="M17.5 25.5H14.5C13.8 25.5 13.2 26.1 13.2 26.8C13.2 27.5 13.8 28.1 14.5 28.1H17.5C18.2 28.1 18.8 27.5 18.8 26.8C18.8 26.1 18.2 25.5 17.5 25.5ZM24.9 22.4H24.1V14.6C24.1 10.5 21.1 7.2 17.2 6.6V5.3C17.2 4.6 16.7 4 16 4C15.3 4 14.7 4.6 14.7 5.3V6.6C10.8 7.2 7.8 10.6 7.8 14.6V22.4H7.2C6.5 22.4 6 23 6 23.7C6 24.4 6.6 25 7.3 25H9.2H23H25C25.7 25 26.3 24.4 26.3 23.7C26.3 23 25.6 22.4 24.9 22.4ZM10.3 22.4V14.6C10.3 11.5 12.8 9 15.9 9C19 9 21.5 11.5 21.5 14.6V22.4H10.3Z"
      fill="#666666"
    />
  </svg>
);

export const SettingIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 32 32" fill="none" className={props.className || ''}>
    <path
      d="M16 12C15.2089 12 14.4355 12.2346 13.7777 12.6741C13.1199 13.1136 12.6072 13.7384 12.3045 14.4693C12.0017 15.2002 11.9225 16.0044 12.0769 16.7804C12.2312 17.5563 12.6122 18.269 13.1716 18.8284C13.731 19.3878 14.4437 19.7688 15.2196 19.9231C15.9956 20.0775 16.7998 19.9983 17.5307 19.6955C18.2616 19.3928 18.8864 18.8801 19.3259 18.2223C19.7654 17.5645 20 16.7911 20 16C20 14.9391 19.5786 13.9217 18.8284 13.1716C18.0783 12.4214 17.0609 12 16 12ZM16 18C15.6044 18 15.2178 17.8827 14.8889 17.6629C14.56 17.4432 14.3036 17.1308 14.1522 16.7654C14.0009 16.3999 13.9613 15.9978 14.0384 15.6098C14.1156 15.2219 14.3061 14.8655 14.5858 14.5858C14.8655 14.3061 15.2219 14.1156 15.6098 14.0384C15.9978 13.9613 16.3999 14.0009 16.7654 14.1522C17.1308 14.3036 17.4432 14.56 17.6629 14.8889C17.8827 15.2178 18 15.6044 18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18Z"
      fill="#666666"
    />
    <path
      d="M26.9998 15.9998C27.0094 15.2822 26.7615 14.5849 26.3009 14.0345C25.8404 13.484 25.1978 13.1169 24.4898 12.9998C24.3788 12.6756 24.2485 12.3584 24.0998 12.0498C24.4922 11.4704 24.6698 10.772 24.6017 10.0756C24.5336 9.37912 24.2242 8.72836 23.727 8.23592C23.2299 7.74348 22.5762 7.44034 21.8791 7.37895C21.182 7.31757 20.4854 7.50181 19.9098 7.89978C19.6142 7.75246 19.3103 7.62224 18.9998 7.50978C18.8841 6.80826 18.5229 6.17063 17.9808 5.7106C17.4387 5.25058 16.7508 4.99805 16.0398 4.99805C15.3288 4.99805 14.6409 5.25058 14.0988 5.7106C13.5566 6.17063 13.1955 6.80826 13.0798 7.50978C12.7556 7.62079 12.4384 7.75102 12.1298 7.89978C11.5548 7.44784 10.8344 7.22153 10.1043 7.26339C9.3741 7.30525 8.68436 7.6124 8.16476 8.1271C7.64515 8.64179 7.33145 9.32857 7.28266 10.0583C7.23386 10.7881 7.45333 11.5105 7.89978 12.0898C7.75102 12.3984 7.62079 12.7156 7.50978 13.0398C6.80826 13.1555 6.17063 13.5166 5.7106 14.0588C5.25058 14.6009 4.99805 15.2888 4.99805 15.9998C4.99805 16.7108 5.25058 17.3987 5.7106 17.9408C6.17063 18.4829 6.80826 18.8441 7.50978 18.9598C7.62079 19.2839 7.75102 19.6011 7.89978 19.9098C7.48046 20.4877 7.281 21.1962 7.33723 21.9079C7.39347 22.6197 7.70172 23.2881 8.20659 23.793C8.71146 24.2978 9.37985 24.6061 10.0916 24.6623C10.8034 24.7186 11.5119 24.5191 12.0898 24.0998C12.3984 24.2485 12.7156 24.3788 13.0398 24.4898C13.1555 25.1913 13.5166 25.8289 14.0588 26.289C14.6009 26.749 15.2888 27.0015 15.9998 27.0015C16.7108 27.0015 17.3987 26.749 17.9408 26.289C18.4829 25.8289 18.8441 25.1913 18.9598 24.4898C19.2839 24.3788 19.6011 24.2485 19.9098 24.0998C20.4877 24.5191 21.1962 24.7186 21.9079 24.6623C22.6197 24.6061 23.2881 24.2978 23.793 23.793C24.2978 23.2881 24.6061 22.6197 24.6623 21.9079C24.7186 21.1962 24.5191 20.4877 24.0998 19.9098C24.2485 19.6011 24.3788 19.2839 24.4898 18.9598C25.191 18.8437 25.8282 18.4824 26.2879 17.9403C26.7476 17.3982 26.9999 16.7105 26.9998 15.9998ZM23.9998 16.9998H23.7398C23.5127 16.9926 23.2899 17.063 23.1082 17.1993C22.9264 17.3356 22.7965 17.5298 22.7398 17.7498C22.5803 18.3836 22.3275 18.9902 21.9898 19.5498C21.8791 19.7408 21.8348 19.9631 21.8638 20.182C21.8927 20.4009 21.9933 20.6041 22.1498 20.7598L22.3298 20.9498C22.4629 21.0238 22.5774 21.1272 22.6645 21.2521C22.7516 21.3771 22.809 21.5203 22.8323 21.6708C22.8556 21.8213 22.8442 21.9752 22.799 22.1206C22.7539 22.2661 22.676 22.3993 22.5715 22.5101C22.467 22.6209 22.3386 22.7063 22.196 22.7599C22.0534 22.8135 21.9005 22.8339 21.7489 22.8194C21.5973 22.8049 21.451 22.7559 21.3211 22.6763C21.1913 22.5966 21.0814 22.4884 20.9998 22.3598L20.8098 22.1798C20.6533 22.0081 20.442 21.8963 20.2121 21.8634C19.9822 21.8306 19.748 21.8788 19.5498 21.9998C18.9902 22.3375 18.3836 22.5903 17.7498 22.7498C17.5298 22.8065 17.3356 22.9364 17.1993 23.1182C17.063 23.2999 16.9926 23.5227 16.9998 23.7498V23.9998C16.9998 24.265 16.8944 24.5194 16.7069 24.7069C16.5194 24.8944 16.265 24.9998 15.9998 24.9998C15.7346 24.9998 15.4802 24.8944 15.2927 24.7069C15.1051 24.5194 14.9998 24.265 14.9998 23.9998V23.7398C15.007 23.5127 14.9366 23.2899 14.8003 23.1082C14.664 22.9264 14.4698 22.7965 14.2498 22.7398C13.616 22.5803 13.0093 22.3275 12.4498 21.9898C12.2944 21.9017 12.1183 21.8568 11.9398 21.8598C11.6774 21.8609 11.426 21.965 11.2398 22.1498L11.0498 22.3298C10.9758 22.4629 10.8724 22.5774 10.7474 22.6645C10.6225 22.7516 10.4793 22.809 10.3288 22.8323C10.1783 22.8556 10.0244 22.8442 9.87895 22.799C9.7335 22.7539 9.60029 22.676 9.48949 22.5715C9.3787 22.467 9.29323 22.3386 9.23963 22.196C9.18603 22.0534 9.1657 21.9005 9.1802 21.7489C9.1947 21.5973 9.24364 21.451 9.32329 21.3211C9.40294 21.1913 9.51119 21.0814 9.63978 20.9998L9.81978 20.8098C9.99143 20.6533 10.1033 20.442 10.1361 20.2121C10.169 19.9822 10.1208 19.748 9.99978 19.5498C9.66204 18.9902 9.40928 18.3836 9.24978 17.7498C9.1931 17.5298 9.06317 17.3356 8.88141 17.1993C8.69965 17.063 8.47688 16.9926 8.24978 16.9998H7.99978C7.73457 16.9998 7.48021 16.8944 7.29268 16.7069C7.10514 16.5194 6.99978 16.265 6.99978 15.9998C6.99978 15.7346 7.10514 15.4802 7.29268 15.2927C7.48021 15.1051 7.73457 14.9998 7.99978 14.9998H8.25978C8.48688 15.007 8.70965 14.9366 8.89141 14.8003C9.07317 14.664 9.2031 14.4698 9.25978 14.2498C9.41928 13.616 9.67204 13.0093 10.0098 12.4498C10.1204 12.2587 10.1647 12.0364 10.1358 11.8175C10.1069 11.5987 10.0063 11.3955 9.84978 11.2398L9.66978 11.0498C9.50596 10.8585 9.42035 10.6124 9.43007 10.3607C9.43979 10.1091 9.54413 9.87032 9.72222 9.69222C9.90032 9.51413 10.1391 9.40979 10.3907 9.40007C10.6424 9.39035 10.8885 9.47596 11.0798 9.63978L11.2698 9.81978C11.4255 9.97629 11.6287 10.0769 11.8475 10.1058C12.0664 10.1347 12.2887 10.0904 12.4798 9.97978C13.0393 9.64204 13.646 9.38928 14.2798 9.22978C14.4998 9.1731 14.694 9.04317 14.8303 8.86141C14.9666 8.67964 15.037 8.45688 15.0298 8.22978V7.99978C15.0298 7.73457 15.1351 7.48021 15.3227 7.29268C15.5102 7.10514 15.7646 6.99978 16.0298 6.99978C16.295 6.99978 16.5494 7.10514 16.7369 7.29268C16.9244 7.48021 17.0298 7.73457 17.0298 7.99978V8.25978C17.0226 8.48688 17.093 8.70965 17.2293 8.89141C17.3656 9.07317 17.5598 9.2031 17.7798 9.25978C18.4136 9.41928 19.0202 9.67204 19.5798 10.0098C19.7708 10.1204 19.9931 10.1647 20.212 10.1358C20.4309 10.1069 20.6341 10.0063 20.7898 9.84978L20.9998 9.63978C21.0894 9.5351 21.1997 9.45008 21.3238 9.39006C21.4479 9.33004 21.583 9.29631 21.7207 9.29099C21.8584 9.28567 21.9958 9.30887 22.1241 9.35915C22.2524 9.40942 22.369 9.48568 22.4664 9.58313C22.5639 9.68059 22.6401 9.79714 22.6904 9.92546C22.7407 10.0538 22.7639 10.1911 22.7586 10.3288C22.7533 10.4666 22.7195 10.6017 22.6595 10.7258C22.5995 10.8498 22.5145 10.9601 22.4098 11.0498L22.2298 11.2398C22.0619 11.3869 21.9481 11.5859 21.9064 11.8052C21.8647 12.0244 21.8976 12.2514 21.9998 12.4498C22.3375 13.0093 22.5903 13.616 22.7498 14.2498C22.8065 14.4698 22.9364 14.664 23.1182 14.8003C23.2999 14.9366 23.5227 15.007 23.7498 14.9998H23.9998C24.265 14.9998 24.5194 15.1051 24.7069 15.2927C24.8944 15.4802 24.9998 15.7346 24.9998 15.9998C24.9998 16.265 24.8944 16.5194 24.7069 16.7069C24.5194 16.8944 24.265 16.9998 23.9998 16.9998Z"
      fill="#666666"
    />
  </svg>
);

export const ProfileIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 22 24" fill="none" className={props.className || ''}>
    <path
      d="M20.999 23.25V20.75C20.999 19.4239 20.4722 18.1521 19.5346 17.2145C18.5969 16.2768 17.3251 15.75 15.999 15.75H5.99902C4.67294 15.75 3.40117 16.2768 2.46349 17.2145C1.52581 18.1521 0.999023 19.4239 0.999023 20.75V23.25"
      stroke="#666666"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.999 10.75C13.7604 10.75 15.999 8.51142 15.999 5.75C15.999 2.98858 13.7604 0.75 10.999 0.75C8.2376 0.75 5.99902 2.98858 5.99902 5.75C5.99902 8.51142 8.2376 10.75 10.999 10.75Z"
      stroke="#666666"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DropDownIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 16 16" fill="none" className={props.className || ''}>
    <path
      d="M4 6.6665L8 10.6665L12 6.6665"
      stroke="#000000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DropRightIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 9 12" fill="none" className={props.className || ''}>
    <path
      d="M4.66051 6.10141L0.764648 2.20692L2.71189 0.258301L8.555 6.10141L2.71189 11.9445L0.764648 9.9959L4.66051 6.10141Z"
      fill="#666666"
    />
  </svg>
);

export const EditIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" className={props.className || ''}>
    <path
      d="M23.0576 7.875C23.6623 7.27031 23.9998 6.46406 23.9998 5.60625C23.9998 4.74844 23.667 3.94219 23.0576 3.3375L20.667 0.946875C20.0576 0.332813 19.2513 0 18.3935 0C17.5357 0 16.7295 0.332813 16.1248 0.942188L1.21383 15.8531C0.379458 16.6875 -0.0611669 17.8359 0.00445805 19.0125L-0.000229449 22.8281C-0.000229449 23.1375 0.121646 23.4375 0.341958 23.6578C0.562271 23.8781 0.857583 24 1.17165 24L4.98727 23.9953C6.16383 24.0609 7.31227 23.6203 8.14665 22.7859C8.60602 22.3266 8.60602 21.5859 8.14665 21.1266C7.68727 20.6672 6.94665 20.6672 6.48727 21.1266C6.12165 21.4922 5.61071 21.6844 5.09508 21.6516C5.07165 21.6516 5.04352 21.6469 5.02008 21.6469L2.34352 21.6562L2.34821 18.9797C2.34821 18.9562 2.34821 18.9281 2.34352 18.9047C2.31071 18.3891 2.5029 17.8781 2.86852 17.5125L15.2951 5.08594L18.9138 8.70469L9.57633 18.0422C9.11696 18.5016 9.11696 19.2422 9.57633 19.7016C10.0357 20.1609 10.7763 20.1609 11.2357 19.7016L23.0576 7.875ZM16.9545 3.42656L17.7841 2.59688C17.9482 2.43281 18.1638 2.34375 18.3982 2.34375C18.6279 2.34375 18.8482 2.43281 19.0123 2.59688L21.4029 4.9875C21.7404 5.325 21.7404 5.87813 21.4029 6.21563L20.5732 7.04531L16.9545 3.42656Z"
      fill="black"
    />
    <path
      d="M22.8281 21.6562H12.2578C11.6109 21.6562 11.0859 22.1812 11.0859 22.8281C11.0859 23.475 11.6109 24 12.2578 24H22.8281C23.475 24 24 23.475 24 22.8281C24 22.1812 23.475 21.6562 22.8281 21.6562Z"
      fill="black"
    />
  </svg>
);

export const DeleteIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 18 24" fill="none" className={props.className || ''}>
    <path
      d="M16.0033 8.7373C15.3564 8.7373 14.8314 9.2623 14.8314 9.90918V20.0436C14.8314 20.9342 14.1096 21.6561 13.2189 21.6561H4.3127C3.42207 21.6561 2.7002 20.9342 2.7002 20.0436V9.90918C2.7002 9.2623 2.1752 8.7373 1.52832 8.7373C0.881445 8.7373 0.356445 9.2623 0.356445 9.90918V20.0436C0.356445 22.2233 2.13301 23.9998 4.3127 23.9998H13.2189C15.3986 23.9998 17.1752 22.2233 17.1752 20.0436V9.90918C17.1752 9.2623 16.6502 8.7373 16.0033 8.7373Z"
      fill="black"
    />
    <path
      d="M16.0033 4.51875H13.7111C13.4861 1.99219 11.3533 0 8.76582 0C6.17832 0 4.04551 1.99219 3.82051 4.51875H1.52832C0.881445 4.51875 0.356445 5.04375 0.356445 5.69063C0.356445 6.3375 0.881445 6.8625 1.52832 6.8625H15.9986C16.6455 6.8625 17.1705 6.3375 17.1705 5.69063C17.1705 5.04375 16.6502 4.51875 16.0033 4.51875ZM8.76582 2.34375C10.0596 2.34375 11.1377 3.28594 11.3486 4.51875H6.18301C6.39395 3.28594 7.47207 2.34375 8.76582 2.34375Z"
      fill="black"
    />
    <path
      d="M7.58936 17.817V12.4639C7.58936 11.817 7.06436 11.292 6.41748 11.292C5.77061 11.292 5.24561 11.817 5.24561 12.4639V17.817C5.24561 18.4639 5.77061 18.9889 6.41748 18.9889C7.06436 18.9889 7.58936 18.4686 7.58936 17.817Z"
      fill="black"
    />
    <path
      d="M12.2861 17.817V12.4639C12.2861 11.817 11.7611 11.292 11.1143 11.292C10.4674 11.292 9.94238 11.817 9.94238 12.4639V17.817C9.94238 18.4639 10.4674 18.9889 11.1143 18.9889C11.7611 18.9889 12.2861 18.4686 12.2861 17.817Z"
      fill="black"
    />
  </svg>
);

export const PreviousIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 14 21" fill="none" className={props.className || ''}>
    <path
      d="M11.512 20.6761L1.04797 11.2361C0.599972 10.8521 0.599972 10.1481 1.04797 9.76415L11.512 0.324149C12.184 -0.283851 13.272 0.164149 13.272 1.06015L13.272 19.9401C13.272 20.8361 12.184 21.2841 11.512 20.6761Z"
      fill="#666666"
    />
  </svg>
);

export const NextIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 14 21" fill="none" className={props.className || ''}>
    <path
      d="M2.48803 0.323851L12.952 9.76385C13.4 10.1479 13.4 10.8519 12.952 11.2359L2.48803 20.6759C1.81603 21.2839 0.728027 20.8359 0.728027 19.9399L0.728028 1.05985C0.728028 0.163851 1.81603 -0.284149 2.48803 0.323851Z"
      fill="#666666"
    />
  </svg>
);

export const EmailIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 28 20" fill="none" className={props.className || ''}>
    <path
      d="M24.0001 0H4.00012C3.00556 0 2.05173 0.395088 1.34847 1.09835C0.64521 1.80161 0.250122 2.75544 0.250122 3.75V16.25C0.250122 17.2446 0.64521 18.1984 1.34847 18.9017C2.05173 19.6049 3.00556 20 4.00012 20H24.0001C24.9947 20 25.9485 19.6049 26.6518 18.9017C27.355 18.1984 27.7501 17.2446 27.7501 16.25V3.75C27.7501 2.75544 27.355 1.80161 26.6518 1.09835C25.9485 0.395088 24.9947 0 24.0001 0ZM25.2501 15.9375L19.1251 10.4375L25.2501 6.15V15.9375ZM2.75012 6.15L8.87512 10.4375L2.75012 15.9375V6.15ZM10.9751 11.9125L13.2876 13.525C13.4969 13.6702 13.7455 13.7479 14.0001 13.7479C14.2548 13.7479 14.5034 13.6702 14.7126 13.525L17.0251 11.9125L23.2751 17.5H4.75012L10.9751 11.9125ZM4.00012 2.5H24.0001C24.2323 2.50186 24.4593 2.56833 24.6558 2.69197C24.8523 2.81561 25.0105 2.99152 25.1126 3.2L14.0001 10.975L2.88762 3.2C2.98976 2.99152 3.14794 2.81561 3.34444 2.69197C3.54093 2.56833 3.76797 2.50186 4.00012 2.5Z"
      fill="white"
    />
  </svg>
);

export const PasswordEyeIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 20 15" fill="none" className={props.className || ''}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8285 7.42338C12.8285 8.82735 11.5617 9.96541 9.99901 9.96541C8.43626 9.96541 7.16943 8.82735 7.16943 7.42338C7.16943 6.01942 8.43626 4.88135 9.99901 4.88135C11.5617 4.88135 12.8285 6.01942 12.8285 7.42338Z"
      stroke="#273773"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 7.4236C2.20187 3.98582 5.77679 1.49219 9.99999 1.49219C14.2232 1.49219 17.7981 3.98585 19 7.4236C17.7981 10.8614 14.2232 13.355 9.99999 13.355C5.77678 13.355 2.20185 10.8614 1 7.4236Z"
      stroke="#273773"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Password: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 12 16">
    <path d="M10.5 6H10V4C10 1.794 8.206 0 6 0C3.794 0 2 1.794 2 4V6H1.5C0.673333 6 0 6.67267 0 7.5V14.5C0 15.3273 0.673333 16 1.5 16H10.5C11.3267 16 12 15.3273 12 14.5V7.5C12 6.67267 11.3267 6 10.5 6ZM3.33333 4C3.33333 2.52933 4.52933 1.33333 6 1.33333C7.47067 1.33333 8.66667 2.52933 8.66667 4V6H3.33333V4ZM6.66667 11.148V12.6667C6.66667 13.0347 6.36867 13.3333 6 13.3333C5.63133 13.3333 5.33333 13.0347 5.33333 12.6667V11.148C4.93667 10.9167 4.66667 10.4913 4.66667 10C4.66667 9.26467 5.26467 8.66667 6 8.66667C6.73533 8.66667 7.33333 9.26467 7.33333 10C7.33333 10.4913 7.06333 10.9167 6.66667 11.148Z" />
  </svg>
);

export const ShowPassword: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 24 15">
    <g opacity="0.5">
      <path d="M12 0C7.41454 0 3.25621 2.50875 0.187788 6.58362C-0.0625959 6.91746 -0.0625959 7.38386 0.187788 7.71771C3.25621 11.7975 7.41454 14.3062 12 14.3062C16.5855 14.3062 20.7438 11.7975 23.8122 7.72261C24.0626 7.38877 24.0626 6.92237 23.8122 6.58853C20.7438 2.50875 16.5855 0 12 0ZM12.3289 12.1902C9.28506 12.3817 6.7714 9.87297 6.96287 6.82418C7.11998 4.31052 9.15741 2.27309 11.6711 2.11599C14.7149 1.92452 17.2286 4.43326 17.0371 7.48205C16.8751 9.9908 14.8377 12.0282 12.3289 12.1902ZM12.1767 9.86315C10.537 9.96625 9.18196 8.61614 9.28997 6.97637C9.37343 5.62136 10.4732 4.52654 11.8282 4.43817C13.4679 4.33507 14.823 5.68518 14.7149 7.32495C14.6266 8.68487 13.5268 9.77969 12.1767 9.86315Z" />
    </g>
  </svg>
);

export const HidePassword: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 24 24">
    <g opacity="0.5" clipPath="url(#clip0_413_768)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5303 1.53033C21.8232 1.82322 21.8232 2.2981 21.5303 2.59099L1.59099 22.5303C1.2981 22.8232 0.823223 22.8232 0.53033 22.5303V22.5303C0.237437 22.2374 0.237437 21.7626 0.53033 21.4697L20.4697 1.53033C20.7626 1.23744 21.2374 1.23744 21.5303 1.53033V1.53033Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7377 6.37194C15.9449 5.48378 14.0136 5 12 5C7.41454 5 3.25621 7.50875 0.187788 11.5836C-0.0625959 11.9175 -0.0625959 12.3839 0.187788 12.7177C1.8942 14.9865 3.93768 16.7695 6.20424 17.9053L8.41003 15.6996C7.43881 14.7166 6.86787 13.3369 6.96287 11.8242C7.11998 9.31052 9.15741 7.27309 11.6711 7.11599C13.1823 7.02093 14.5628 7.59143 15.5464 8.56315L17.7377 6.37194ZM19.0939 7.13701L16.4535 9.77743C16.88 10.5749 17.0988 11.5005 17.0371 12.482C16.8751 14.9908 14.8377 17.0282 12.3289 17.1902C11.3481 17.2519 10.4223 17.0333 9.6244 16.6065L7.6874 18.5435C9.06466 19.0413 10.5098 19.3062 12 19.3062C16.5855 19.3062 20.7438 16.7975 23.8122 12.7226C24.0626 12.3888 24.0626 11.9224 23.8122 11.5885C22.4382 9.76158 20.8455 8.24968 19.0939 7.13701ZM11.4235 14.8074C11.6643 14.8593 11.917 14.8795 12.1767 14.8631C13.5268 14.7797 14.6266 13.6849 14.7149 12.3249C14.7321 12.0646 14.7124 11.8115 14.6605 11.5704L11.4235 14.8074ZM13.9041 10.2054C13.3754 9.68955 12.6364 9.38736 11.8282 9.43817C10.4732 9.52654 9.37343 10.6214 9.28997 11.9764C9.23667 12.7855 9.5396 13.5241 10.0572 14.0524L13.9041 10.2054Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_413_768">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Email: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 16 16">
    <path
      d="M12.6667 6.01533C12.6667 6.01533 9.208 5.79333 8 7.30733C9.33333 4.04333 12.6667 3.34867 12.6667 3.34867V2.01533L16 4.682L12.6667 7.36133V6.01533ZM0.0173333 15.974H15.982L8 8.236L0.0173333 15.974ZM1.13267 6.64067L7.99333 1.64867L10.0287 3.12733C10.5033 2.82133 10.956 2.59067 11.3307 2.42467L7.99333 0L0 5.81667V14.134L4.90133 9.38267L1.13267 6.64067ZM11.6347 9.902L16 14.134V6.39267L11.6347 9.902Z"
      fill="#273773"
    />
  </svg>
);

export const AddImage: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 44 44" fill="none">
    <path
      d="M5.07254 2.67872H30.7202C33.513 2.67872 35.7928 4.95851 35.7928 7.75126V29.1399C35.7928 31.9326 33.513 35.2124 30.7202 35.2124H17.8964H5.07254C2.27979 35.2124 0 32.9326 0 30.1399V7.69426C0 4.95851 2.27979 2.67872 5.07254 2.67872Z"
      fill="#273773"
    />
    <path
      d="M16.5855 26.5596L9.06218 19.0362L0 28.0984V29.9793V34.0829C0 36.8756 2.27979 39.1554 5.07254 39.1554H30.7202C33.513 39.1554 35.7928 36.8756 35.7928 34.0829V29.9793V24.3368L27.3005 15.7875L16.5855 26.5596Z"
      fill="#8BD8BD"
    />
    <path
      d="M16.3575 17.9534C18.1202 17.9534 19.5492 16.5244 19.5492 14.7617C19.5492 12.999 18.1202 11.57 16.3575 11.57C14.5948 11.57 13.1658 12.999 13.1658 14.7617C13.1658 16.5244 14.5948 17.9534 16.3575 17.9534Z"
      fill="white"
    />
    <path
      d="M35.7927 41.3212C40.3255 41.3212 44 37.6467 44 33.114C44 28.5812 40.3255 24.9067 35.7927 24.9067C31.26 24.9067 27.5854 28.5812 27.5854 33.114C27.5854 37.6467 31.26 41.3212 35.7927 41.3212Z"
      fill="white"
    />
    <path
      d="M31.9171 34.3109C31.2902 34.3109 30.7202 33.7979 30.7202 33.114C30.7202 32.4301 31.2332 31.9171 31.9171 31.9171H39.6684C40.3523 31.9171 40.8653 32.4301 40.8653 33.114C40.8653 33.7979 40.3523 34.3109 39.6684 34.3109H31.9171Z"
      fill="#8BD8BD"
    />
    <path
      d="M36.9895 36.9897C36.9895 37.6736 36.4765 38.1866 35.7926 38.1866C35.1087 38.1866 34.5957 37.6736 34.5957 36.9897V29.2954C34.5957 28.6684 35.1087 28.0985 35.7926 28.0985C36.4195 28.0985 36.9895 28.6114 36.9895 29.2954V36.9897Z"
      fill="#8BD8BD"
    />
  </svg>
);

export const AddPdf: React.FC<Props> = (props) => (
  <svg viewBox="0 0 44 44" fill="none" className={props.className || ''}>
    <g clipPath="url(#clip0_1350_4665)">
      <path
        d="M31.625 28.4167C22.7883 28.4167 15.5833 21.2117 15.5833 12.375C15.5833 7.40667 17.8567 2.95167 21.4317 0H5.04167C2.255 0 0 2.255 0 5.04167V38.9583C0 41.745 2.255 44 5.04167 44H31.625C34.4117 44 36.6667 41.745 36.6667 38.9583V27.61C35.09 28.1233 33.385 28.4167 31.625 28.4167Z"
        fill="#8BD8BD"
      />
      <path
        d="M31.625 24.75C24.8013 24.75 19.25 19.1987 19.25 12.375C19.25 5.55133 24.8013 0 31.625 0C38.4487 0 44 5.55133 44 12.375C44 19.1987 38.4487 24.75 31.625 24.75Z"
        fill="#273773"
      />
      <path
        d="M31.6247 19.25C30.6127 19.25 29.7914 18.4287 29.7914 17.4167V7.33333C29.7914 6.32133 30.6127 5.5 31.6247 5.5C32.6367 5.5 33.4581 6.32133 33.4581 7.33333V17.4167C33.4581 18.4287 32.6367 19.25 31.6247 19.25Z"
        fill="white"
      />
      <path
        d="M36.6667 14.2087H26.5833C25.5713 14.2087 24.75 13.3873 24.75 12.3753C24.75 11.3633 25.5713 10.542 26.5833 10.542H36.6667C37.6787 10.542 38.5 11.3633 38.5 12.3753C38.5 13.3873 37.6787 14.2087 36.6667 14.2087Z"
        fill="white"
      />
      <path
        d="M31.6247 14.2083H29.7914V17.4167C29.7914 18.4287 30.6127 19.25 31.6247 19.25V14.2083ZM31.6247 5.5C30.6127 5.5 29.7914 6.32133 29.7914 7.33333V10.5417H31.6247V5.5Z"
        fill="#DEDEDE"
      />
      <path
        d="M31.625 10.542H29.7917H26.5833C25.5713 10.542 24.75 11.3633 24.75 12.3753C24.75 13.3873 25.5713 14.2087 26.5833 14.2087H29.7917H31.625V10.542Z"
        fill="#DEDEDE"
      />
      <path
        d="M9.16666 29.333H6.875C6.12333 29.333 5.5 29.9563 5.5 30.708V38.958C5.5 39.7097 6.12333 40.333 6.875 40.333C7.62666 40.333 8.25 39.7097 8.25 38.958V36.6663H9.16666C11.1833 36.6663 12.8333 35.0163 12.8333 32.9997C12.8333 30.983 11.1833 29.333 9.16666 29.333ZM9.16666 33.9163H8.25V32.083H9.16666C9.68 32.083 10.0833 32.4863 10.0833 32.9997C10.0833 33.513 9.68 33.9163 9.16666 33.9163Z"
        fill="#273773"
      />
      <path
        d="M18.7914 29.333H16.0414C15.2897 29.333 14.6664 29.9563 14.6664 30.708V38.958C14.6664 39.7097 15.2897 40.333 16.0414 40.333H18.7914C20.5514 40.333 21.9997 38.8847 21.9997 37.1247V32.5413C21.9997 30.7813 20.5514 29.333 18.7914 29.333ZM19.2497 37.1247C19.2497 37.3813 19.048 37.583 18.7914 37.583H17.4164V32.083H18.7914C19.048 32.083 19.2497 32.2847 19.2497 32.5413V37.1247Z"
        fill="#273773"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8337 38.958C23.8337 39.717 24.4497 40.333 25.2087 40.333C25.9677 40.333 26.5837 39.717 26.5837 38.958V36.6662H29.7913C30.5503 36.6662 31.1663 36.0502 31.1663 35.2912C31.1663 34.5322 30.5503 33.9162 29.7913 33.9162H26.5837V32.5413C26.5837 32.2883 26.7891 32.083 27.0421 32.083H29.7921C30.5511 32.083 31.1671 31.467 31.1671 30.708C31.1671 29.949 30.5511 29.333 29.7921 29.333H27.0421C25.2729 29.333 23.8337 30.7722 23.8337 32.5413V38.958Z"
        fill="#273773"
      />
    </g>
    <defs>
      <clipPath id="clip0_1350_4665">
        <rect width="44" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Pdf: React.FC<Props> = (props) => (
  <svg viewBox="0 0 52 52" fill="none" className={props.className || ''}>
    <path
      d="M6.49988 3.12001C6.49988 1.39668 7.89656 0 9.61989 0H32.4999L45.4999 10.92V48.88C45.4999 50.6033 44.1033 52 42.3799 52H9.61989C7.89656 52 6.49988 50.6033 6.49988 48.88V3.12001Z"
      fill="#8BD8BD"
    />
    <path
      d="M32.5 0V7.79997C32.5 9.52329 33.8967 10.92 35.62 10.92H45.5001"
      fill="#70BBA1"
    />
    <path
      d="M16.2841 32.9707H15.0654V36.709H12.3671V25.4453H15.9266C18.9987 25.4453 20.7536 26.6479 20.7536 29.1186C20.7529 31.769 18.9492 32.9707 16.2841 32.9707ZM15.9592 27.3628H15.0655V31.0198H16.0567C17.2755 31.0198 17.9742 30.434 17.9742 29.1178C17.9742 27.9323 17.3079 27.3628 15.9592 27.3628Z"
      fill="white"
    />
    <path
      d="M25.0104 36.709H21.9546V25.4453H24.8154C27.7095 25.4453 30.4712 26.3716 30.4712 31.0215C30.4713 35.6024 27.8217 36.709 25.0104 36.709ZM25.2046 27.3953H24.6521V34.7589H25.2046C26.6834 34.7589 27.6746 33.9627 27.6746 31.0198C27.6762 28.0144 26.6192 27.3953 25.2046 27.3953Z"
      fill="white"
    />
    <path
      d="M35.1667 27.3628V30.3219H39.1001V32.2556H35.1667V36.709H32.4521V25.4453H39.88L39.6038 27.3628H35.1667Z"
      fill="white"
    />
  </svg>
);

export const Delete: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 26 30" fill="none">
    <path d="M22.8438 3.75H17.6875V2.8125C17.6875 1.25918 16.4283 0 14.875 0H11.125C9.57168 0 8.3125 1.25918 8.3125 2.8125V3.75H3.15625C1.86186 3.75 0.8125 4.79936 0.8125 6.09375V7.96875C0.8125 8.48654 1.23221 8.90625 1.75 8.90625H24.25C24.7678 8.90625 25.1875 8.48654 25.1875 7.96875V6.09375C25.1875 4.79936 24.1381 3.75 22.8438 3.75ZM10.1875 2.8125C10.1875 2.2957 10.6082 1.875 11.125 1.875H14.875C15.3918 1.875 15.8125 2.2957 15.8125 2.8125V3.75H10.1875V2.8125Z" />
    <path d="M2.59164 10.7812C2.42435 10.7812 2.29105 10.9211 2.29902 11.0882L3.07246 27.3211C3.14394 28.8234 4.37793 30 5.88145 30H20.1186C21.6221 30 22.8561 28.8234 22.9275 27.3211L23.701 11.0882C23.709 10.9211 23.5757 10.7812 23.4084 10.7812H2.59164ZM16.75 13.125C16.75 12.607 17.1695 12.1875 17.6875 12.1875C18.2055 12.1875 18.625 12.607 18.625 13.125V25.3125C18.625 25.8305 18.2055 26.25 17.6875 26.25C17.1695 26.25 16.75 25.8305 16.75 25.3125V13.125ZM12.0625 13.125C12.0625 12.607 12.482 12.1875 13 12.1875C13.518 12.1875 13.9375 12.607 13.9375 13.125V25.3125C13.9375 25.8305 13.518 26.25 13 26.25C12.482 26.25 12.0625 25.8305 12.0625 25.3125V13.125ZM7.375 13.125C7.375 12.607 7.79453 12.1875 8.3125 12.1875C8.83047 12.1875 9.25 12.607 9.25 13.125V25.3125C9.25 25.8305 8.83047 26.25 8.3125 26.25C7.79453 26.25 7.375 25.8305 7.375 25.3125V13.125Z" />
  </svg>
);

export const Close: React.FC<Props> = (props) => (
  <svg viewBox="0 0 16 16" className={props.className || ''}>
    <path d="M11 5L5 11" stroke="white" strokeWidth="1.5" />
    <path d="M5 5L11 11" stroke="white" strokeWidth="1.5" />
  </svg>
);

export const DeleteOption: React.FC<Props> = (props) => (
  <svg viewBox="0 0 52 53" fill="none" className={props.className || ''}>
    <path
      d="M13.642 38.9264C6.11967 31.404 6.11967 19.1645 13.642 11.6421C21.1644 4.11976 33.4039 4.11976 40.9263 11.6421C48.4487 19.1645 48.4487 31.404 40.9263 38.9264C33.4039 46.4488 21.1644 46.4488 13.642 38.9264Z"
      fill="#273773"
    />
    <path
      d="M19.7809 32.787C18.6514 31.6575 18.631 29.8443 19.7355 28.7399L30.7401 17.7352C31.8446 16.6308 33.6577 16.6511 34.7873 17.7807C35.9169 18.9103 35.9372 20.7234 34.8328 21.8279L23.8281 32.8325C22.7236 33.937 20.9105 33.9166 19.7809 32.787Z"
      fill="white"
    />
    <path
      d="M30.7403 32.8325L19.7356 21.8279C18.6311 20.7234 18.6515 18.9103 19.7811 17.7807C20.9106 16.6511 22.7238 16.6308 23.8282 17.7352L34.8329 28.7399C35.9374 29.8443 35.917 31.6575 34.7874 32.787C33.6579 33.9166 31.8447 33.937 30.7403 32.8325Z"
      fill="white"
    />
  </svg>
);

export const PlusIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 30 30" fill="none" className={props.className || ''}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 30C16.7143 30 18 28.4746 18 26.4407V18H26.4607C28.4831 18 30 16.7143 30 15C30 13.2857 28.4831 12 26.4607 12H18V3.55933C18 1.52543 16.5714 0 15 0C13.2857 0 12 1.69492 12 3.55933V12H3.53932C1.51685 12 0 13.2857 0 15C0 16.7143 1.68539 18 3.53932 18H12V26.4407C12 28.4746 13.2857 30 15 30Z"
      fill="#8BD7BC"
    />
  </svg>
);

export const CloseLogo: React.FC<Props> = (props) => (
  <svg viewBox="0 0 16 16" className={props.className || ''}>
    <path d="M11 5L5 11" stroke="white" strokeWidth="1.5" />
    <path d="M5 5L11 11" stroke="white" strokeWidth="1.5" />
  </svg>
);

export const ProfilePlaceholder: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 20 22" fill="none">
    <path
      d="M18.7778 20.9999V18.7777C18.7778 17.599 18.3095 16.4685 17.476 15.635C16.6425 14.8015 15.5121 14.3333 14.3333 14.3333H5.44444C4.2657 14.3333 3.13524 14.8015 2.30175 15.635C1.46825 16.4685 1 17.599 1 18.7777V20.9999"
      stroke="#666666"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.88927 9.88889C12.3439 9.88889 14.3337 7.89904 14.3337 5.44444C14.3337 2.98985 12.3439 1 9.88927 1C7.43467 1 5.44482 2.98985 5.44482 5.44444C5.44482 7.89904 7.43467 9.88889 9.88927 9.88889Z"
      stroke="#666666"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Logout: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 19 20" fill="none">
    <path
      d="M14.2791 5.11465C13.9242 4.75968 13.3485 4.75962 12.9935 5.11459C12.6385 5.46962 12.6385 6.04519 12.9935 6.40022L15.684 9.09089H4.54544C4.04338 9.09089 3.63635 9.49792 3.63635 9.99998C3.63635 10.502 4.04338 10.9091 4.54544 10.9091H15.6839L12.9935 13.5995C12.6385 13.9545 12.6385 14.5301 12.9935 14.8851C13.171 15.0626 13.4037 15.1514 13.6364 15.1514C13.869 15.1514 14.1017 15.0626 14.2791 14.8851L18.5214 10.6428C18.8765 10.2879 18.8765 9.71222 18.5214 9.35719L14.2791 5.11465Z"
      fill="#999999"
    />
    <path
      d="M8.78788 20C9.28994 20 9.69697 19.593 9.69697 19.0909C9.69697 18.5888 9.28994 18.1818 8.78788 18.1818H1.81818V1.81818H8.78788C9.28994 1.81818 9.69697 1.41115 9.69697 0.909091C9.69697 0.40703 9.28994 0 8.78788 0H0.909091C0.40703 0 0 0.40703 0 0.909091V19.0909C0 19.593 0.40703 20 0.909091 20H8.78788Z"
      fill="#999999"
    />
  </svg>
);

export const Profile: React.FC<Props> = (props) => (
  <svg viewBox="0 0 50 50" fill="none" className={props.className || ''}>
    <circle cx="25" cy="25" r="25" fill="#F3F3F3" />
    <path
      d="M33.3332 34.375V32.2917C33.3332 31.1866 32.8942 30.1268 32.1128 29.3454C31.3314 28.564 30.2716 28.125 29.1665 28.125H20.8332C19.7281 28.125 18.6683 28.564 17.8869 29.3454C17.1055 30.1268 16.6665 31.1866 16.6665 32.2917V34.375"
      stroke="#666666"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.0002 23.9583C27.3013 23.9583 29.1668 22.0929 29.1668 19.7917C29.1668 17.4905 27.3013 15.625 25.0002 15.625C22.699 15.625 20.8335 17.4905 20.8335 19.7917C20.8335 22.0929 22.699 23.9583 25.0002 23.9583Z"
      stroke="#666666"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownArrow: React.FC<Props> = (props) => (
  <svg viewBox="0 0 16 16" fill="none" className={props.className || ''}>
    <path
      d="M4 6.66669L8 10.6667L12 6.66669"
      stroke="#999999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CategoryDecoration: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 18 57">
    <path
      d="M12.3492 36.2907C18.5789 32.0107 18.5789 25.0879 12.3492 20.8277C4.56933 15.4827 0.205698 8.24429 0.205698 0.690311L0.205698 -6.95493e-07L-4.3869e-05 -7.44035e-07L-4.63606e-05 57L0.205696 57L0.205696 56.4083C0.205696 48.8543 4.56933 41.6159 12.3492 36.2907Z"
      fill="#273773"
    />
    <path
      d="M12.348 27.8857L5.68251 23.3225C5.37468 23.1116 5.06452 23 4.80672 23C4.30831 23 4 23.4 4 24.0696V33.932C4 34.6008 4.30792 35 4.80517 35C5.06336 35 5.36856 34.8883 5.67707 34.6768L12.3457 30.1137C12.7746 29.8198 13.0121 29.4242 13.0121 28.9995C13.0122 28.575 12.7774 28.1795 12.348 27.8857Z"
      fill="white"
    />
  </svg>
);

export const SmartDevice: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 40 40">
    <g filter="url(#filter0_d_215_1007)">
      <path
        d="M21.3602 27.9843H16.6399V36H18.1399H19.8602H21.3602V27.9843Z"
        fill="white"
      />
      <path
        d="M19.0001 15.7711C18.5187 15.7711 18.1271 16.1626 18.1271 16.644C18.1271 17.1253 18.5187 17.5169 19.0001 17.5169C19.4814 17.5169 19.873 17.1253 19.873 16.644C19.873 16.1626 19.4814 15.7711 19.0001 15.7711Z"
        fill="white"
      />
      <path
        d="M26.0724 14.848L18.998 10.5184L11.8762 14.8788V21.6392H26.0724V14.848ZM18.9999 19.5091C17.4201 19.5091 16.1348 18.2238 16.1348 16.644C16.1348 15.0642 17.42 13.7789 18.9999 13.7789C20.5798 13.7789 21.865 15.0641 21.865 16.644C21.865 18.2238 20.5797 19.5091 18.9999 19.5091Z"
        fill="white"
      />
      <path
        d="M18.9979 8.26039L29.9298 14.9508L30.9697 13.2516L18.9977 5.92468L7.03027 13.2517L8.07046 14.9507L18.9979 8.26039Z"
        fill="white"
      />
      <path
        d="M2 23.0798V36.0001H9.88408V17.8931L2 23.0798ZM4.94505 29.5693V26.2913H6.93724V29.5693H4.94505Z"
        fill="white"
      />
      <path
        d="M36.0001 23.0798L28.0648 17.8595V36.0001H36.0001V23.0798ZM33.0015 29.5694H31.0093V26.2914H33.0015V29.5694Z"
        fill="white"
      />
      <path
        d="M11.8762 23.6313V36H14.6476V25.992H23.3522V36H26.0724V23.6313H11.8762Z"
        fill="white"
      />
      <path
        d="M34.008 10.3141H36.0002C36.0002 5.72971 32.2705 2 27.6861 2V3.99219C31.172 3.99219 34.008 6.8282 34.008 10.3141Z"
        fill="white"
      />
      <path
        d="M30.0236 10.3141H32.0158C32.0158 7.92669 30.0735 5.98438 27.6861 5.98438V7.97656C28.975 7.97656 30.0236 9.02518 30.0236 10.3141Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_215_1007"
        x="0"
        y="0"
        width="40.0002"
        height="40.0001"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1" dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_215_1007"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_215_1007"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const Inventory: React.FC<Props> = (props) => (
  <svg viewBox="0 0 512 512" className={props.className || ''}>
    <path
      d="m357.384 357.616a50.982 50.982 0 0 1 10.7 12.129 47.012 47.012 0 0 1 4.1 8.141c.052.136.1.273.155.41l73.846-40.669q-6.707-8.043-15.474-9.445-12.5-2-30.777 8.183-1.263.7-3.5 2.055l-.01-.016a8.682 8.682 0 0 1 -.944.491l-38.088 18.721zm16.034-248v151.328a8.679 8.679 0 0 1 -8.679 8.678h-191.425a8.678 8.678 0 0 1 -8.678-8.678v-151.328h-15.4a8.678 8.678 0 0 1 -4.8-15.908l119.336-91.59a8.662 8.662 0 0 1 10.654.112l55.268 42.418v-16.934a8.678 8.678 0 1 1 17.356 0v30.255l47.019 36.087a8.658 8.658 0 0 1 -5.255 15.54v.02zm-80.736 142.65v-72.139h-47.311v72.139zm-198.777 120.819 1.561-1.042c29.623-19.8 57.17-38.2 121.458-14.076a8.6 8.6 0 0 0 3.356.538q18.288-.723 42.07-.94 23.664-.215 53.062.053 14.568 3.227 24.251 8.766 9.249 5.292 13.775 12.51a29.763 29.763 0 0 1 2.538 5.158l.035.091-136.4 26.658a8.67 8.67 0 0 0 3.322 17.018l146.547-28.641a8.659 8.659 0 0 0 2.509-.911l89.635-49.367q21.177-4.091 34-2.811 8.145.813 12.235 3.683a9.292 9.292 0 0 1 3.863 6.036 16.554 16.554 0 0 1 .279 2.2l-188.285 131.8q-25.33 7.012-73.4 1.741-50.5-5.538-124.77-24.558a8.614 8.614 0 0 0 -6.606.979l-25.035 14.121zm-17.356-30.12h-76.549v168.694h76.549zm240.251-2.617 19.8-11.256q22.288-10.263 34.4-8.292a14.038 14.038 0 0 1 9.684 6.1l-41.051 20.177a119.255 119.255 0 0 0 -21.363-6.569v.017a8.7 8.7 0 0 0 -1.47-.177z"
      fill="white"
    />
  </svg>
);

export const Folder: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 34 34">
    <path
      d="M28.3406 16.3713C28.2314 15.6436 27.6075 15.1192 26.8733 15.1192H14.9795L12.8194 12.5625C12.3616 12.025 11.6897 11.6863 10.9828 11.6863H3.255C2.70434 11.6863 2.18099 11.9441 1.82481 12.3659C1.46972 12.7887 1.31785 13.3678 1.41072 13.9108L1.61613 15.1192H1.48065C1.04799 15.1192 0.638271 15.2951 0.35857 15.6228C0.0745 15.9517 -0.0489615 16.38 0.0176859 16.8072L2.41699 32.3743C2.5623 33.3106 3.36863 34 4.31589 34H29.2234C29.6561 34 30.0658 33.8099 30.3455 33.4854C30.6263 33.1576 30.753 32.7326 30.6886 32.3054L28.3406 16.3713Z"
      fill="white"
    />
    <path
      d="M22.4189 4.75378H13.1156C12.4743 4.75378 11.9542 5.33285 11.9542 5.97529C11.9542 6.61772 12.4754 7.19679 13.1156 7.19679H22.4189C23.0625 7.19679 23.5814 6.61772 23.5814 5.97529C23.5814 5.33285 23.0603 4.75378 22.4189 4.75378Z"
      fill="white"
    />
    <path
      d="M33.3797 13.3142C33.112 13.0028 32.7198 12.8073 32.3079 12.8073H29.6682L30.2691 18.3739L31.7037 28.099L33.7118 14.4505C33.7676 14.044 33.6496 13.6267 33.3797 13.3142Z"
      fill="white"
    />
    <path
      d="M9.72176 2.24525H25.9619V13.2705H28.2082V1.428C28.2071 0.645714 27.5537 0 26.7715 0H8.81164C7.95287 0 7.27985 0.706898 7.27985 1.56567V10.1009H9.72176V2.24525Z"
      fill="white"
    />
    <path
      d="M22.4184 9.24316H13.1151C12.5568 9.24316 12.0914 9.68457 11.9788 10.2254C12.7753 10.4286 13.4997 10.8624 14.0449 11.5015L14.2142 11.6851H22.4184C23.0619 11.6851 23.5809 11.106 23.5809 10.4636C23.5809 9.82114 23.0598 9.24316 22.4184 9.24316Z"
      fill="white"
    />
  </svg>
);

export const Calender: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 34 34">
    <path
      d="M24.9688 7.96875C23.8685 7.96875 22.9766 7.07685 22.9766 5.97656V1.99219C22.9766 0.891902 23.8685 0 24.9688 0C26.069 0 26.9609 0.891902 26.9609 1.99219V5.97656C26.9609 7.07685 26.069 7.96875 24.9688 7.96875Z"
      fill="white"
    />
    <path
      d="M30.3477 3.98438H28.9531V5.97656C28.9531 8.17355 27.1657 9.96094 24.9688 9.96094C22.7718 9.96094 20.9844 8.17355 20.9844 5.97656V3.98438H13.0156V5.97656C13.0156 8.17355 11.2282 9.96094 9.03125 9.96094C6.83427 9.96094 5.04688 8.17355 5.04688 5.97656V3.98438H3.65234C1.63844 3.98438 0 5.62282 0 7.63672V12.0859H34V7.63672C34 5.62282 32.3616 3.98438 30.3477 3.98438Z"
      fill="white"
    />
    <path
      d="M9.03125 7.96875C7.93096 7.96875 7.03906 7.07685 7.03906 5.97656V1.99219C7.03906 0.891902 7.93096 0 9.03125 0C10.1315 0 11.0234 0.891902 11.0234 1.99219V5.97656C11.0234 7.07685 10.1315 7.96875 9.03125 7.96875Z"
      fill="white"
    />
    <path
      d="M0 14.0781V30.3477C0 32.3616 1.63844 34 3.65234 34H30.3477C32.3616 34 34 32.3616 34 30.3477V14.0781H0ZM18.0468 27.0273C18.0468 29.2243 16.2594 31.0117 14.0625 31.0117C12.0857 31.0117 10.3893 29.5372 10.1164 27.5818C10.091 27.3994 10.0781 27.2129 10.0781 27.0273C10.0781 26.4772 10.5241 26.0312 11.0742 26.0312C11.6243 26.0312 12.0703 26.4772 12.0703 27.0273C12.0703 27.1211 12.0768 27.215 12.0895 27.3065C12.2257 28.2831 13.0739 29.0195 14.0625 29.0195C15.1609 29.0195 16.0546 28.1258 16.0546 27.0273C16.0546 25.9289 15.1609 25.0352 14.0625 25.0352C13.5123 25.0352 13.0664 24.5892 13.0664 24.0391C13.0664 23.489 13.5123 23.043 14.0625 23.043C15.1609 23.043 16.0546 22.1493 16.0546 21.0508C16.0546 19.9523 15.1609 19.0586 14.0625 19.0586C13.1124 19.0586 12.2903 19.7336 12.1077 20.6636C12.0015 21.2034 11.4775 21.5549 10.9383 21.449C10.3985 21.343 10.0468 20.8194 10.1529 20.2796C10.5185 18.4178 12.1627 17.0664 14.0625 17.0664C16.2594 17.0664 18.0468 18.8538 18.0468 21.0508C18.0468 22.24 17.5225 23.3084 16.6937 24.0391C17.5225 24.7697 18.0468 25.8381 18.0468 27.0273ZM23.9219 30.0156C23.9219 30.5657 23.4759 31.0117 22.9258 31.0117C22.3757 31.0117 21.9297 30.5657 21.9297 30.0156V19.0586H20.371C19.8209 19.0586 19.3749 18.6126 19.3749 18.0625C19.3749 17.5124 19.8209 17.0664 20.371 17.0664H22.9258C23.4759 17.0664 23.9219 17.5124 23.9219 18.0625V30.0156Z"
      fill="white"
    />
  </svg>
);

export const Education: React.FC<Props> = (props) => (
  <svg viewBox="0 0 511.99767 511" className={props.className || ''}>
    <path d="m70.621094 353.578125h123.585937v70.621094h-123.585937zm0 0" />
    <path d="m282.484375 284.546875v51.375h123.585937v-70.621094h-33.191406zm0 0" />
    <path d="m188.910156 265.300781h-47.667968v70.621094h123.585937v-47.667969l-56.320313 12.003906c-1.394531.277344-2.8125.425782-4.238281.441407-7.195312-.082031-13.828125-3.898438-17.519531-10.074219s-3.910156-13.828125-.578125-20.203125zm0 0" />
    <path d="m17.65625 300.613281h-17.65625v35.308594h123.585938v-70.621094h-123.585938v17.65625h17.65625c4.875 0 8.828125 3.953125 8.828125 8.828125s-3.953125 8.828125-8.828125 8.828125zm35.308594-17.65625h35.3125c4.875 0 8.824218 3.953125 8.824218 8.828125s-3.949218 8.828125-8.824218 8.828125h-35.3125c-4.875 0-8.828125-3.953125-8.828125-8.828125s3.953125-8.828125 8.828125-8.828125zm0 0" />
    <path d="m211.863281 353.578125h123.585938v70.621094h-123.585938zm0 0" />
    <path d="m299.34375 217.632812c-2.773438-.019531-5.382812-1.324218-7.0625-3.53125-2.910156-3.902343-2.121094-9.425781 1.765625-12.359374l36.457031-27.363282-39.898437-53.144531c-.554688-.765625-1.4375-1.222656-2.386719-1.234375h-.175781c-.679688.046875-1.28125.449219-1.585938 1.058594l-84.746093 157.660156c-.457032 1.003906-.332032 2.179688.332031 3.0625.660156.882812 1.753906 1.332031 2.84375 1.175781l175.140625-37.253906c.6875-.0625 1.257812-.5625 1.414062-1.234375.347656-.925781.179688-1.96875-.441406-2.738281l-39.902344-53.230469-36.457031 27.367188c-1.535156 1.128906-3.390625 1.746093-5.296875 1.765624zm0 0" />
    <path d="m353.101562 353.578125h123.589844v70.621094h-123.589844zm0 0" />
    <path d="m282.484375 441.851562h123.585937v70.621094h-123.585937zm0 0" />
    <path d="m0 441.851562h123.585938v70.621094h-123.585938zm0 0" />
    <path d="m141.242188 441.851562h123.585937v70.621094h-123.585937zm0 0" />
    <path d="m501.761719 11.066406c-8.796875-11.667968-25.367188-14.035156-37.078125-5.296875l-72.828125 54.644531c-3.886719 2.933594-4.675781 8.453126-1.765625 12.359376l7.769531 10.328124-18.363281 13.769532c-8.207032 6.136718-12.785156 15.988281-12.179688 26.21875l.882813 15.890625c.230469 4.320312-1.726563 8.464843-5.207031 11.03125l-32.488282 24.367187 10.59375 14.121094 32.484375-24.363281c8.207031-6.101563 12.785157-15.921875 12.183594-26.128907l-.882813-15.890624c-.214843-4.339844 1.738282-8.507813 5.207032-11.121094l18.363281-13.773438 7.765625 10.328125c1.429688 1.855469 3.515625 3.089844 5.828125 3.445313.40625.074218.820313.105468 1.234375.085937 1.910156-.003906 3.769531-.621093 5.296875-1.765625l72.828125-54.640625c11.695312-8.777343 14.066406-25.375 5.296875-37.078125zm-10.949219 29.484375-65.765625 49.347657-7.765625-10.328126-7.769531-10.328124 65.765625-49.347657c3.902344-2.917969 9.429687-2.128906 12.359375 1.765625l4.941406 6.53125c1.417969 1.863282 2.023437 4.21875 1.679687 6.535156-.335937 2.320313-1.574218 4.414063-3.445312 5.824219zm0 0" />
  </svg>
);

export const Contact: React.FC<Props> = (props) => (
  <svg viewBox="0 0 442 442" className={props.className || ''}>
    <g>
      <path d="M105.4,221c0,9.391-7.609,17-17,17h-34c-9.391,0-17-7.609-17-17l0,0c0-9.391,7.609-17,17-17h34   C97.792,204,105.4,211.609,105.4,221L105.4,221z M105.4,112.2c0-9.391-7.609-17-17-17h-34c-9.391,0-17,7.609-17,17l0,0   c0,9.391,7.609,17,17,17h34C97.792,129.2,105.4,121.591,105.4,112.2L105.4,112.2z M105.4,329.801c0-9.393-7.609-17-17-17h-34   c-9.391,0-17,7.607-17,17l0,0c0,9.391,7.609,17,17,17h34C97.792,346.801,105.4,339.191,105.4,329.801L105.4,329.801z M404.6,54.4   v333.2c0,30.043-24.357,54.4-54.398,54.4h-238c-30.042,0-54.4-24.357-54.4-54.4V360.4h30.6c16.871,0,30.6-13.73,30.6-30.6   c0-16.871-13.729-30.602-30.6-30.602H57.8v-47.6h30.6c16.871,0,30.6-13.729,30.6-30.6s-13.729-30.6-30.6-30.6H57.8v-47.6h30.6   c16.871,0,30.6-13.729,30.6-30.6c0-16.871-13.729-30.6-30.6-30.6H57.8V54.4c0-30.042,24.358-54.4,54.4-54.4h238   C380.242,0,404.6,24.357,404.6,54.4z M188.945,161.255c0,28.968,23.487,52.455,52.455,52.455c28.969,0,52.455-23.487,52.455-52.455   c0-28.968-23.486-52.456-52.455-52.456C212.433,108.8,188.945,132.287,188.945,161.255z M323,289.482   c0-32.184-26.098-58.283-58.283-58.283H218.09c-32.191,0-58.29,26.1-58.29,58.283v23.318H323V289.482z" />
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

export const FilterIcon: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 30 29">
    <path
      d="M27.964 0.288086H2.03619C1.42934 0.288086 0.9375 0.779897 0.9375 1.38672C0.9375 4.44616 2.24906 7.36699 4.53593 9.39968L9.34764 13.6762C10.182 14.4178 10.6605 15.4834 10.6605 16.5998V27.3132C10.6605 28.1887 11.639 28.7136 12.3684 28.2271L18.8505 23.9062C19.156 23.7023 19.3397 23.3594 19.3397 22.9921V16.5998C19.3397 15.4834 19.8183 14.4178 20.6526 13.6762L25.4641 9.39968C27.7509 7.36699 29.0625 4.44616 29.0625 1.38672C29.0625 0.779897 28.5707 0.288086 27.964 0.288086ZM24.0042 7.7573L19.1927 12.034C17.8898 13.1923 17.1423 14.8564 17.1423 16.5996V22.4041L12.8577 25.2604V16.5998C12.8577 14.8564 12.1102 13.1923 10.8073 12.034L5.99577 7.75752C4.45374 6.38658 3.46943 4.50818 3.20591 2.48514H26.7941C26.5306 4.50818 25.5465 6.38658 24.0042 7.7573Z"
      fill="white"
    />
  </svg>
);

export const Person: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 15 16">
    <path d="M7.03125 0C4.70503 0 2.8125 1.89253 2.8125 4.21875C2.8125 6.54497 4.70503 8.4375 7.03125 8.4375C9.35747 8.4375 11.25 6.54497 11.25 4.21875C11.25 1.89253 9.35747 0 7.03125 0Z" />
    <path d="M12.2802 11.1936C11.1252 10.0208 9.59403 9.375 7.96875 9.375H6.09375C4.4685 9.375 2.93731 10.0208 1.78231 11.1936C0.632969 12.3606 0 13.901 0 15.5312C0 15.7901 0.209875 16 0.46875 16H13.5938C13.8526 16 14.0625 15.7901 14.0625 15.5312C14.0625 13.901 13.4295 12.3606 12.2802 11.1936Z" />
  </svg>
);

export const Correct: React.FC<Props> = (props) => (
  <svg viewBox="0 0 12 10" className={props.className || ''} fill="none">
    <path
      d="M4.0001 7.78002L1.2201 5.00002L0.273438 5.94002L4.0001 9.66668L12.0001 1.66668L11.0601 0.726685L4.0001 7.78002Z"
      fill="white"
    />
  </svg>
);

export const EditLogo: React.FC<Props> = (props) => (
  <svg viewBox="0 0 19 19" fill="none" className={props.className || ''}>
    <path
      d="M0 15.2501V19.0001H3.75L14.81 7.94006L11.06 4.19006L0 15.2501ZM17.71 5.04006C18.1 4.65006 18.1 4.02006 17.71 3.63006L15.37 1.29006C14.98 0.900059 14.35 0.900059 13.96 1.29006L12.13 3.12006L15.88 6.87006L17.71 5.04006Z"
      fill="#273773"
    />
  </svg>
);

export const CloseIcon: React.FC<Props> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className={props.className || ''}
  >
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H42V40H3C1.34315 40 0 38.6569 0 37V3Z"
      fill="#243665"
    />
    <path
      d="M12.7503 25.5004V27.3338H29.2503V25.5004H12.7503ZM25.954 12.5791L24.6578 13.8753L27.5747 16.7921L24.6578 19.7089L25.954 21.0051L30.167 16.7921L25.954 12.5791ZM12.7503 19.0838V20.9171H21.0003V19.0838H12.7503ZM12.7503 12.6671V14.5004H21.0003V12.6671H12.7503Z"
      fill="white"
    />
  </svg>
);

export const ManageAdsIcon: React.FC<Props> = (props) => (
  <svg fill="none" className={props.className || ''}>
    <path
      d="M12.0292 9.24023H11.7324V11.4061H12.0554C12.5357 11.3977 12.877 10.9534 12.877 10.326C12.8773 9.80088 12.6543 9.24023 12.0292 9.24023Z"
      fill="#666666"
    />
    <path
      d="M8.22925 10.715H8.8311L8.53001 9.87988L8.22925 10.715Z"
      fill="#666666"
    />
    <path
      d="M12.7729 6.09027C10.4376 4.74199 7.43997 5.54491 6.09136 7.88055C5.438 9.01181 5.26485 10.3298 5.60283 11.5917C5.94115 12.8536 6.75038 13.9084 7.88164 14.5614C8.64967 15.0051 9.48947 15.2158 10.319 15.2158C12.0106 15.2158 13.6579 14.3384 14.5632 12.7715C15.9118 10.4362 15.1086 7.43854 12.7729 6.09027V6.09027ZM9.92948 12.3451C9.87564 12.3647 9.82048 12.374 9.76631 12.374C9.56923 12.374 9.38445 12.2521 9.31367 12.056L9.17741 11.6775H7.88264L7.74638 12.056C7.65632 12.3056 7.38015 12.4358 7.1309 12.3454C6.88099 12.2554 6.75138 11.9799 6.84144 11.73L7.93581 8.69277C8.0385 8.43521 8.26948 8.27868 8.53036 8.27868C8.79091 8.27868 9.02188 8.43521 9.11892 8.67715L10.2193 11.73C10.309 11.9795 10.1794 12.2554 9.92948 12.3451V12.3451ZM12.0644 12.368H11.2518C10.9863 12.368 10.7709 12.1527 10.7709 11.8872V8.75924C10.7709 8.4937 10.9863 8.27835 11.2518 8.27835H12.0295C13.0953 8.27835 13.8394 9.12048 13.8394 10.3262C13.839 11.4724 13.0763 12.3504 12.0644 12.368Z"
      fill="#666666"
    />
    <path
      d="M10.3259 0C4.63206 0 0 4.63206 0 10.3259C0 16.0198 4.63206 20.6519 10.3259 20.6519C16.0198 20.6519 20.6519 16.0198 20.6519 10.3259C20.6519 4.63206 16.0198 0 10.3259 0V0ZM10.3259 18.9902C8.23555 18.9902 6.31599 18.2461 4.8175 17.0092L6.67691 15.1497C6.22892 14.8121 5.83178 14.4203 5.49779 13.9789L3.64271 15.834C2.40543 14.3359 1.66167 12.4163 1.66167 10.3259C1.66167 5.5483 5.5483 1.66167 10.3259 1.66167C12.4163 1.66167 14.3359 2.40576 15.8344 3.64271L13.9763 5.50078C14.4239 5.83843 14.8211 6.23025 15.1547 6.67192L17.0092 4.8175C18.2464 6.31599 18.9902 8.23555 18.9902 10.3259C18.9902 15.1036 15.1036 18.9902 10.3259 18.9902V18.9902Z"
      fill="#666666"
    />
  </svg>
);

export const SecureFolder: React.FC<Props> = (props) => (
  <svg viewBox="0 0 512 512" className={props.className || ''}>
    <g>
      <g>
        <path d="M511.997,135.944v-30.941c0-24.813-20.189-44.999-45.002-44.999H244.539c-5.719,0-10.859-3.177-13.417-8.292    L217.707,24.88c-7.671-15.344-23.094-24.876-40.248-24.876H45.001c-24.813,0-44.998,20.187-45,44.999L0,377.731    c0,24.448,19.643,44.168,44.131,44.167l106.871-0.001v45.099c0,24.813,20.187,44.999,44.999,44.999H316    c24.813,0,44.999-20.187,44.999-44.999v-44.999h105.995h0.007c24.811-0.002,44.995-20.188,44.995-44.999V136.06    c0-0.02,0.003-0.039,0.003-0.058C512,135.983,511.997,135.963,511.997,135.944z M331,466.997c0,8.271-6.729,15-15,15H196.002    c-8.271,0-15-6.729-15-15v-89.999c0-8.271,6.729-15,15-15H316c8.271,0,15,6.729,15,15V466.997z M211.002,331.999V286    c0-24.813,20.187-44.999,44.999-44.999C280.814,241,301,261.187,301,286v45.999H211.002z M481.997,376.998    c0,7.807-6.065,15-15.605,15H360.999v-15c0-19.555-12.541-36.227-30-42.419V286c0-41.354-33.644-74.999-74.999-74.999    c-41.354,0-74.999,33.644-74.999,74.999v48.579c-17.459,6.192-30,22.865-30,42.419v15L44.13,391.999    c-7.849,0-14.131-6.345-14.131-14.268l0.001-226.729h451.997V376.998z M481.997,121.002H30.001V45.004    c0.001-8.272,6.729-15.001,15.001-15.001h132.457c5.718,0,10.858,3.177,13.416,8.292l13.417,26.833    c7.672,15.343,23.095,24.875,40.248,24.875h222.456c8.271,0,15.003,6.729,15.003,15V121.002z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M256.001,391.998c-8.284,0-15,6.716-15,15v30c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15v-30    C271.001,398.714,264.285,391.998,256.001,391.998z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M436.998,181.001h-60.999c-8.284,0-15,6.716-15,15s6.716,15,15,15h60.999c8.284,0,15-6.716,15-15    S445.282,181.001,436.998,181.001z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M436.998,241h-60.999c-8.284,0-15,6.716-15,15s6.716,15,15,15h60.999c8.284,0,15-6.716,15-15S445.282,241,436.998,241z" />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

export const AscOrder: React.FC<Props> = (props) => (
  <svg viewBox="0 0 8 12" fill="none" className={props.className || ''}>
    <path
      d="M6.97963 3.42862H5.26535V11.7143C5.26535 11.7976 5.23865 11.8662 5.18504 11.9197C5.13144 11.9731 5.06305 12 4.97964 12H3.26533C3.18205 12 3.11347 11.9733 3.05996 11.9197C3.00652 11.8661 2.97966 11.7976 2.97966 11.7143V3.42866H1.26534C1.1345 3.42866 1.04518 3.36917 0.997524 3.25015C0.949833 3.13691 0.970785 3.0328 1.05998 2.93755L3.91709 0.0803099C3.98257 0.026927 4.05097 0.000188828 4.12246 0.000188828C4.19983 0.000188828 4.26834 0.026927 4.32783 0.0803099L7.17603 2.92857C7.23563 2.99984 7.26534 3.07152 7.26534 3.1426C7.26534 3.22629 7.23848 3.29456 7.18503 3.3485C7.13146 3.40185 7.06307 3.42862 6.97963 3.42862Z"
      fill="#666666"
    />
  </svg>
);

export const DescOrder: React.FC<Props> = (props) => (
  <svg viewBox="0 0 7 12" fill="none" className={props.className || ''}>
    <path
      d="M6.00698 8.57138H4.2927V0.285708C4.2927 0.202429 4.26599 0.133847 4.21239 0.0803394C4.15879 0.026863 4.09039 0 4.00699 0H2.29268C2.2094 0 2.14082 0.0267386 2.08731 0.0803089C2.03386 0.133942 2.007 0.202429 2.007 0.285677V8.57134H0.292688C0.161842 8.57134 0.0725272 8.63083 0.0248675 8.74985C-0.0228236 8.86309 -0.00187078 8.9672 0.0873192 9.06245L2.94443 11.9197C3.00992 11.9731 3.07831 11.9998 3.1498 11.9998C3.22717 11.9998 3.29569 11.9731 3.35517 11.9197L6.20337 9.07143C6.26298 9.00016 6.29269 8.92848 6.29269 8.8574C6.29269 8.77371 6.26582 8.70544 6.21238 8.6515C6.15881 8.59815 6.09041 8.57138 6.00698 8.57138Z"
      fill="#666666"
    />
  </svg>
);

export const CompanyLogo: React.FC<Props> = (props) => (
  <svg viewBox="0 0 16 16" fill="none" className={props.className || ''}>
    <g clipPath="url(#clip0_2281_2011)">
      <path
        d="M8.68667 1.24714L1.36 0.133809C1.02 0.0804753 0.673333 0.173809 0.413333 0.393809C0.153333 0.620475 0 0.947142 0 1.28714V15.3338C0 15.7005 0.3 16.0005 0.666667 16.0005H2.83333V12.5005C2.83333 11.8538 3.35333 11.3338 4 11.3338H5.66667C6.31333 11.3338 6.83333 11.8538 6.83333 12.5005V16.0005H9.66667V2.40048C9.66667 1.82714 9.25333 1.34048 8.68667 1.24714ZM3.66667 9.83381H2.66667C2.39067 9.83381 2.16667 9.60981 2.16667 9.33381C2.16667 9.05781 2.39067 8.83381 2.66667 8.83381H3.66667C3.94267 8.83381 4.16667 9.05781 4.16667 9.33381C4.16667 9.60981 3.94267 9.83381 3.66667 9.83381ZM3.66667 7.83381H2.66667C2.39067 7.83381 2.16667 7.60981 2.16667 7.33381C2.16667 7.05781 2.39067 6.83381 2.66667 6.83381H3.66667C3.94267 6.83381 4.16667 7.05781 4.16667 7.33381C4.16667 7.60981 3.94267 7.83381 3.66667 7.83381ZM3.66667 5.83381H2.66667C2.39067 5.83381 2.16667 5.60981 2.16667 5.33381C2.16667 5.05781 2.39067 4.83381 2.66667 4.83381H3.66667C3.94267 4.83381 4.16667 5.05781 4.16667 5.33381C4.16667 5.60981 3.94267 5.83381 3.66667 5.83381ZM3.66667 3.83381H2.66667C2.39067 3.83381 2.16667 3.60981 2.16667 3.33381C2.16667 3.05781 2.39067 2.83381 2.66667 2.83381H3.66667C3.94267 2.83381 4.16667 3.05781 4.16667 3.33381C4.16667 3.60981 3.94267 3.83381 3.66667 3.83381ZM7 9.83381H6C5.724 9.83381 5.5 9.60981 5.5 9.33381C5.5 9.05781 5.724 8.83381 6 8.83381H7C7.276 8.83381 7.5 9.05781 7.5 9.33381C7.5 9.60981 7.276 9.83381 7 9.83381ZM7 7.83381H6C5.724 7.83381 5.5 7.60981 5.5 7.33381C5.5 7.05781 5.724 6.83381 6 6.83381H7C7.276 6.83381 7.5 7.05781 7.5 7.33381C7.5 7.60981 7.276 7.83381 7 7.83381ZM7 5.83381H6C5.724 5.83381 5.5 5.60981 5.5 5.33381C5.5 5.05781 5.724 4.83381 6 4.83381H7C7.276 4.83381 7.5 5.05781 7.5 5.33381C7.5 5.60981 7.276 5.83381 7 5.83381ZM7 3.83381H6C5.724 3.83381 5.5 3.60981 5.5 3.33381C5.5 3.05781 5.724 2.83381 6 2.83381H7C7.276 2.83381 7.5 3.05781 7.5 3.33381C7.5 3.60981 7.276 3.83381 7 3.83381Z"
        fill="#273773"
      />
      <path
        d="M15.0797 7.22838L10.333 6.23438V16.0004H14.833C15.4763 16.0004 15.9997 15.477 15.9997 14.8337V8.36838C15.9997 7.81771 15.6243 7.34904 15.0797 7.22838ZM13.4997 14.0004H12.4997C12.2237 14.0004 11.9997 13.7764 11.9997 13.5004C11.9997 13.2244 12.2237 13.0004 12.4997 13.0004H13.4997C13.7757 13.0004 13.9997 13.2244 13.9997 13.5004C13.9997 13.7764 13.7757 14.0004 13.4997 14.0004ZM13.4997 12.0004H12.4997C12.2237 12.0004 11.9997 11.7764 11.9997 11.5004C11.9997 11.2244 12.2237 11.0004 12.4997 11.0004H13.4997C13.7757 11.0004 13.9997 11.2244 13.9997 11.5004C13.9997 11.7764 13.7757 12.0004 13.4997 12.0004ZM13.4997 10.0004H12.4997C12.2237 10.0004 11.9997 9.77638 11.9997 9.50038C11.9997 9.22438 12.2237 9.00038 12.4997 9.00038H13.4997C13.7757 9.00038 13.9997 9.22438 13.9997 9.50038C13.9997 9.77638 13.7757 10.0004 13.4997 10.0004Z"
        fill="#273773"
      />
    </g>
    <defs>
      <clipPath id="clip0_2281_2011">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ManagerIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 32 24" fill="none" className={props.className || ''}>
    <path
      d="M16.0637 0C12.7898 0 10.1328 2.65695 10.1328 5.93088C10.1328 9.20482 12.7898 11.8618 16.0637 11.8618C19.3376 11.8618 21.9946 9.20482 21.9946 5.93088C21.9946 2.65695 19.3376 0 16.0637 0ZM16.0637 9.4883C14.1016 9.4883 12.5063 7.89302 12.5063 5.93088C12.5063 3.96875 14.1016 2.37347 16.0637 2.37347C18.0258 2.37347 19.6211 3.96875 19.6211 5.93088C19.6211 7.89302 18.0258 9.4883 16.0637 9.4883Z"
      fill="#808080"
    />
    <path
      d="M19.6209 14.2305H12.5061C9.23214 14.2305 6.5752 16.8874 6.5752 20.1614V22.5348C6.5752 23.1907 7.10881 23.7188 7.75915 23.7188H24.3623C25.0182 23.7188 25.5462 23.1852 25.5462 22.5348V20.1614C25.5518 16.8874 22.8949 14.2305 19.6209 14.2305ZM23.1783 21.3453H8.94866V20.1614C8.94866 18.1992 10.5439 16.6039 12.5061 16.6039H19.6209C21.5831 16.6039 23.1783 18.1992 23.1783 20.1614V21.3453Z"
      fill="#808080"
    />
    <path
      d="M22.5127 11.8562V9.48275C24.4748 9.48275 26.0701 7.88747 26.0701 5.92533C26.0701 3.96319 24.4748 2.36791 22.5127 2.36791V0C25.7866 0 28.4436 2.65695 28.4436 5.93089C28.4436 9.20482 25.7866 11.8562 22.5127 11.8562Z"
      fill="#808080"
    />
    <path
      d="M32.0003 20.1614V22.5348C32.0003 23.1907 31.4667 23.7188 30.8163 23.7188H27.2589V21.3453H29.6268V20.1614C29.6268 18.1992 28.0316 16.6039 26.0694 16.6039H25.0967V14.2305H26.0694C29.3433 14.2305 32.0003 16.8874 32.0003 20.1614Z"
      fill="#808080"
    />
    <path
      d="M3.55762 5.93088C3.55762 2.65695 6.21456 0 9.4885 0V2.37347C7.52636 2.37347 5.93108 3.96875 5.93108 5.93088C5.93108 7.89302 7.52636 9.4883 9.4885 9.4883V11.8618C6.21456 11.8562 3.55762 9.20482 3.55762 5.93088Z"
      fill="#808080"
    />
    <path
      d="M5.93089 14.2305H6.90362V16.6039H5.93089C3.96875 16.6039 2.37347 18.1992 2.37347 20.1614V21.3453H4.74693V23.7188H1.18951C0.533613 23.7188 0 23.1852 0 22.5293V20.1558C0 16.8874 2.65695 14.2305 5.93089 14.2305Z"
      fill="#808080"
    />
  </svg>
);

export const OwnersIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 28 28" fill="none" className={props.className || ''}>
    <path
      d="M22.9025 10.8688V3.95C22.9025 3.75109 22.8235 3.56032 22.6828 3.41967C22.5422 3.27902 22.3514 3.2 22.1525 3.2H17.7987C17.5998 3.2 17.4091 3.27902 17.2684 3.41967C17.1278 3.56032 17.0487 3.75109 17.0487 3.95V4.82375L14.54 2.22875C14.47 2.1563 14.3861 2.09871 14.2933 2.05941C14.2005 2.0201 14.1008 1.9999 14 2C13.8038 1.99983 13.6153 2.07657 13.475 2.21375L10.9288 4.6925C10.8135 4.13533 10.5593 3.61635 10.1897 3.18377C9.82009 2.7512 9.34714 2.41908 8.81478 2.21829C8.28243 2.0175 7.70796 1.95455 7.14476 2.03529C6.58155 2.11604 6.0479 2.33785 5.59341 2.68012C5.13891 3.02239 4.77832 3.47401 4.54515 3.993C4.31198 4.51198 4.2138 5.0815 4.25973 5.6486C4.30566 6.2157 4.49422 6.76199 4.80787 7.23669C5.12152 7.71139 5.5501 8.09908 6.05375 8.36375H5C4.20435 8.36375 3.44129 8.67982 2.87868 9.24243C2.31607 9.80504 2 10.5681 2 11.3638L2 16.625C2 17.1223 2.19754 17.5992 2.54917 17.9508C2.90081 18.3025 3.37772 18.5 3.875 18.5C4.00098 18.5009 4.1267 18.4883 4.25 18.4625V23.9375C4.25099 24.4842 4.46861 25.0082 4.85519 25.3948C5.24177 25.7814 5.7658 25.999 6.3125 26C6.79187 26.0013 7.25645 25.8341 7.625 25.5275C7.99355 25.8341 8.45813 26.0013 8.9375 26H22.625C22.8239 26 23.0147 25.921 23.1553 25.7803C23.296 25.6397 23.375 25.4489 23.375 25.25V15.125H25.25C25.3973 15.1251 25.5414 15.0819 25.6643 15.0007C25.7872 14.9194 25.8834 14.8038 25.941 14.6682C25.9986 14.5326 26.015 14.3831 25.9882 14.2382C25.9613 14.0934 25.8924 13.9597 25.79 13.8538L22.9025 10.8688ZM7.625 3.5C7.99584 3.5 8.35835 3.60997 8.66669 3.81599C8.97504 4.02202 9.21536 4.31486 9.35727 4.65747C9.49919 5.00008 9.53632 5.37708 9.46397 5.74079C9.39163 6.10451 9.21305 6.4386 8.95083 6.70083C8.6886 6.96305 8.35451 7.14163 7.99079 7.21397C7.62708 7.28632 7.25008 7.24919 6.90747 7.10727C6.56486 6.96536 6.27202 6.72504 6.06599 6.41669C5.85997 6.10835 5.75 5.74584 5.75 5.375C5.75 4.87772 5.94754 4.40081 6.29917 4.04918C6.65081 3.69754 7.12772 3.5 7.625 3.5ZM6.3125 24.5C6.16332 24.5 6.02024 24.4407 5.91475 24.3352C5.80926 24.2298 5.75 24.0867 5.75 23.9375V12.875C5.75 12.6761 5.67098 12.4853 5.53033 12.3447C5.38968 12.204 5.19891 12.125 5 12.125C4.80109 12.125 4.61032 12.204 4.46967 12.3447C4.32902 12.4853 4.25 12.6761 4.25 12.875V16.625C4.25 16.7245 4.21049 16.8198 4.14016 16.8902C4.06984 16.9605 3.97446 17 3.875 17C3.77554 17 3.68016 16.9605 3.60984 16.8902C3.53951 16.8198 3.5 16.7245 3.5 16.625V11.375C3.5 10.9772 3.65804 10.5956 3.93934 10.3143C4.22064 10.033 4.60218 9.875 5 9.875H10.25H10.3813H10.4225C10.7897 9.91751 11.1283 10.0941 11.3733 10.3709C11.6183 10.6478 11.7525 11.0053 11.75 11.375V16.625C11.75 16.7245 11.7105 16.8198 11.6402 16.8902C11.5698 16.9605 11.4745 17 11.375 17C11.2755 17 11.1802 16.9605 11.1098 16.8902C11.0395 16.8198 11 16.7245 11 16.625V12.875C11 12.6761 10.921 12.4853 10.7803 12.3447C10.6397 12.204 10.4489 12.125 10.25 12.125C10.0511 12.125 9.86032 12.204 9.71967 12.3447C9.57902 12.4853 9.5 12.6761 9.5 12.875V23.9375C9.5 24.0867 9.44074 24.2298 9.33525 24.3352C9.22976 24.4407 9.08668 24.5 8.9375 24.5C8.78832 24.5 8.64524 24.4407 8.53975 24.3352C8.43426 24.2298 8.375 24.0867 8.375 23.9375V17C8.375 16.8011 8.29598 16.6103 8.15533 16.4697C8.01468 16.329 7.82391 16.25 7.625 16.25C7.42609 16.25 7.23532 16.329 7.09467 16.4697C6.95402 16.6103 6.875 16.8011 6.875 17V23.9375C6.875 24.0867 6.81574 24.2298 6.71025 24.3352C6.60476 24.4407 6.46168 24.5 6.3125 24.5ZM22.625 13.625C22.4261 13.625 22.2353 13.704 22.0947 13.8447C21.954 13.9853 21.875 14.1761 21.875 14.375V24.5H10.9213C10.9723 24.3168 10.9988 24.1277 11 23.9375V18.4625C11.1233 18.4881 11.249 18.5007 11.375 18.5C11.8723 18.5 12.3492 18.3025 12.7008 17.9508C13.0525 17.5992 13.25 17.1223 13.25 16.625V11.375C13.2558 10.6403 12.9917 9.92894 12.5078 9.37597C12.024 8.823 11.354 8.46682 10.625 8.375H10.5125C10.43 8.375 10.34 8.375 10.2537 8.375H9.3125L9.5075 8.1875C9.84168 7.96111 10.1325 7.6766 10.3663 7.3475L14 3.81125L17.2738 7.18625C17.3776 7.29395 17.5112 7.36814 17.6575 7.39931C17.8038 7.43048 17.956 7.41719 18.0947 7.36115C18.2334 7.30511 18.3522 7.20888 18.4358 7.08483C18.5193 6.96078 18.5639 6.81458 18.5637 6.665V4.7H21.4175V11.1725C21.4173 11.3669 21.4926 11.5538 21.6275 11.6938L23.5025 13.625H22.625Z"
      fill="#808080"
      stroke="#808080"
      strokeWidth="0.3"
    />
  </svg>
);

export const Logo: React.FC<Props> = (props) => (
  <svg viewBox="0 0 549 468" fill="none" className={props.className || ''}>
    <path
      d="M48.7953 335.527H49.7102L61.9599 380.01H79.4449L98.6072 307.398H79.3941L69.7875 355.554H68.8726L56.7246 307.398H41.781L30.0396 355.554H29.1247L19.3656 307.398H0L19.1623 380.01H36.749L48.7953 335.527Z"
      fill="#666666"
    />
    <path
      d="M161.889 365.166H130.273V350.321H160.008V336.735H130.273V322.242H161.889V307.398H111.619V380.01H161.889V365.166Z"
      fill="#666666"
    />
    <path
      d="M227.61 364.763H196.452V307.398H177.798V380.01H227.61V364.763Z"
      fill="#666666"
    />
    <path
      d="M271.729 381.973C290.535 381.973 304.158 370.248 304.767 353.642H286.876C285.808 361.442 279.811 366.575 271.78 366.575C261.512 366.575 255.261 357.819 255.261 343.629C255.261 329.489 261.512 320.834 271.729 320.834C279.76 320.834 285.808 326.167 286.774 334.068H304.717C304.158 317.613 290.18 305.436 271.729 305.436C249.72 305.436 236.251 319.978 236.251 343.679C236.251 367.38 249.771 381.973 271.729 381.973Z"
      fill="#666666"
    />
    <path
      d="M351.021 305.436C329.013 305.436 314.832 320.079 314.832 343.679C314.832 367.329 328.86 381.973 351.021 381.973C373.081 381.973 387.11 367.329 387.11 343.679C387.11 320.079 373.081 305.436 351.021 305.436ZM351.021 320.733C361.289 320.733 368.151 329.69 368.151 343.679C368.151 357.718 361.34 366.675 351.021 366.675C340.602 366.675 333.841 357.718 333.841 343.679C333.841 329.69 340.703 320.733 351.021 320.733Z"
      fill="#666666"
    />
    <path
      d="M481.447 380.01V307.398H459.438L441.699 351.78H440.734L422.944 307.398H400.935V380.01H418.166V334.168H419.081L435.447 374.425H446.986L463.301 334.168H464.216V380.01H481.447Z"
      fill="#666666"
    />
    <path
      d="M548.998 365.166H517.383V350.321H547.118V336.735H517.383V322.242H548.998V307.398H498.729V380.01H548.998V365.166Z"
      fill="#666666"
    />
    <path
      d="M51.2739 466.355V413.858H37.8243V434.449H16.6944V413.858H3.20801V466.355H16.6944V445.182H37.8243V466.355H51.2739Z"
      fill="#666666"
    />
    <path
      d="M87.4335 412.439C71.5218 412.439 61.2692 423.026 61.2692 440.088C61.2692 457.187 71.4116 467.774 87.4335 467.774C103.382 467.774 113.524 457.187 113.524 440.088C113.524 423.026 103.382 412.439 87.4335 412.439ZM87.4335 423.499C94.8565 423.499 99.8175 429.975 99.8175 440.088C99.8175 450.238 94.8933 456.714 87.4335 456.714C79.9003 456.714 75.0128 450.238 75.0128 440.088C75.0128 429.975 79.9738 423.499 87.4335 423.499Z"
      fill="#666666"
    />
    <path
      d="M181.728 466.355V413.858H165.816L152.991 445.946H152.293L139.431 413.858H123.52V466.355H135.977V433.213H136.639L148.471 462.317H156.813L168.609 433.213H169.27V466.355H181.728Z"
      fill="#666666"
    />
    <path
      d="M230.565 455.623H207.708V444.891H229.206V435.068H207.708V424.59H230.565V413.858H194.222V466.355H230.565V455.623Z"
      fill="#666666"
    />
    <path
      d="M284.18 412.439C268.268 412.439 258.016 423.026 258.016 440.088C258.016 457.187 268.158 467.774 284.18 467.774C300.129 467.774 310.271 457.187 310.271 440.088C310.271 423.026 300.129 412.439 284.18 412.439ZM284.18 423.499C291.603 423.499 296.564 429.975 296.564 440.088C296.564 450.238 291.64 456.714 284.18 456.714C276.647 456.714 271.76 450.238 271.76 440.088C271.76 429.975 276.72 423.499 284.18 423.499Z"
      fill="#666666"
    />
    <path
      d="M333.055 466.355V436.523H333.753L355.912 466.355H366.605V413.858H353.817V443.399H353.119L331.033 413.858H320.266V466.355H333.055Z"
      fill="#666666"
    />
    <path
      d="M415.149 455.332H392.622V413.858H379.136V466.355H415.149V455.332Z"
      fill="#666666"
    />
    <path
      d="M438.483 466.355V413.858H424.997V466.355H438.483Z"
      fill="#666666"
    />
    <path
      d="M463.803 466.355V436.523H464.501L486.66 466.355H497.353V413.858H484.565V443.399H483.867L461.781 413.858H451.014V466.355H463.803Z"
      fill="#666666"
    />
    <path
      d="M546.227 455.623H523.37V444.891H544.868V435.068H523.37V424.59H546.227V413.858H509.884V466.355H546.227V455.623Z"
      fill="#666666"
    />
    <path d="M0 0H135.785V138.495L0 273.033V0Z" fill="#8BD8BD" />
    <path d="M548.999 0H412.98V138.495L548.999 273.033V0Z" fill="#8BD8BD" />
    <path
      d="M282.022 3.13229C277.8 -1.0441 270.965 -1.0441 266.756 3.13229L138.945 129.609C136.927 131.606 135.783 134.332 135.783 137.177V229.424C135.783 251.071 153.514 268.621 175.382 268.621H238.661V171.617H310.103V268.621H373.383C395.249 268.621 412.981 251.071 412.981 229.425V137.177C412.981 134.332 411.847 131.606 409.819 129.609L282.022 3.13229Z"
      fill="#243665"
    />
  </svg>
);

export const BreadCrumbs: React.FC<Props> = (props) => (
  <svg className={props.className || ''} viewBox="0 0 11 10" fill="none">
    <path
      d="M6 9L10 5L6 1"
      stroke="#999999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 9L5 5L1 1"
      stroke="#999999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ResetIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 122.88 110.668" className={props.className || ''}>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.124,15.645c12.928,0,23.406,10.479,23.406,23.406 c0,12.927-10.479,23.406-23.406,23.406c-12.927,0-23.406-10.479-23.406-23.406C67.718,26.125,78.197,15.645,91.124,15.645 L91.124,15.645z M2.756,0h117.322c1.548,0,2.802,1.254,2.802,2.802c0,0.848-0.368,1.622-0.996,2.139l-10.667,13.556 c-1.405-1.375-2.95-2.607-4.614-3.672l6.628-9.22H9.43l37.975,46.171c0.59,0.516,0.958,1.254,0.958,2.102v49.148l21.056-9.623 V57.896c1.651,1.9,3.548,3.582,5.642,4.996v32.133c0,1.105-0.627,2.064-1.586,2.506l-26.476,12.758 c-1.327,0.773-3.023,0.332-3.798-1.033c-0.258-0.441-0.368-0.92-0.368-1.4V55.02L0.803,4.756c-1.07-1.106-1.07-2.839,0-3.945 C1.355,0.258,2.056,0,2.756,0L2.756,0z M96.93,28.282c1.328-1.349,3.489-1.355,4.825-0.013c1.335,1.342,1.341,3.524,0.013,4.872 l-5.829,5.914l5.836,5.919c1.317,1.338,1.299,3.506-0.04,4.843c-1.34,1.336-3.493,1.333-4.81-0.006l-5.797-5.878l-5.807,5.889 c-1.329,1.349-3.489,1.355-4.826,0.013c-1.335-1.342-1.341-3.523-0.013-4.872l5.83-5.913l-5.836-5.919 c-1.317-1.338-1.3-3.507,0.04-4.843c1.339-1.336,3.492-1.333,4.81,0.006l5.796,5.878L96.93,28.282L96.93,28.282z"
      />
    </g>
  </svg>
);

export const SortIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 490 490" className={props.className}>
    <g>
      <polygon
        points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 
		0,194.27 37.087,221.213 	"
      />
      <polygon
        points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 
		490,295.715 452.913,268.802 	"
      />
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

export const DateTime: React.FC<Props> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" className={props.className || ''}>
    <path
      d="M19.9024 2.59972H19.1794V1.81085C19.1794 0.811919 18.3912 0 17.4212 0C16.4506 0 15.663 0.811919 15.663 1.81085V2.59906H13.8588V1.81085C13.8588 0.811919 13.0706 0 12.1006 0C11.1307 0 10.3424 0.811919 10.3424 1.81085V2.59906H8.53818V1.81085C8.53818 0.811919 7.74996 0 6.78001 0C5.81005 0 5.02184 0.811919 5.02184 1.81085V2.59906H4.09863C2.55579 2.59906 1.30005 3.8548 1.30005 5.39765V21.2014C1.30005 22.7443 2.55579 24 4.09863 24H19.9024C21.4459 24 22.701 22.7443 22.701 21.2014V5.39765C22.701 3.85546 21.4452 2.59972 19.9024 2.59972ZM16.6508 1.81085C16.6508 1.35715 16.9965 0.987736 17.4212 0.987736C17.8466 0.987736 18.1916 1.35715 18.1916 1.81085V5.03482C18.1916 5.48852 17.8466 5.85793 17.4212 5.85793C16.9965 5.85793 16.6508 5.48852 16.6508 5.03482V1.81085ZM11.3302 1.81085C11.3302 1.35715 11.6759 0.987736 12.1006 0.987736C12.5253 0.987736 12.871 1.35715 12.871 1.81085V5.03482C12.871 5.48852 12.5253 5.85793 12.1006 5.85793C11.6759 5.85793 11.3302 5.48852 11.3302 5.03482V1.81085ZM6.00891 1.81085C6.00891 1.35715 6.35462 0.987736 6.77935 0.987736C7.20407 0.987736 7.54978 1.35715 7.54978 1.81085V5.03482C7.54978 5.48852 7.20407 5.85793 6.77935 5.85793C6.35462 5.85793 6.00891 5.48852 6.00891 5.03482V1.81085ZM21.0548 21.2021C21.0548 21.8375 20.5378 22.3544 19.9024 22.3544H4.09863C3.46319 22.3544 2.94627 21.8375 2.94627 21.2021V6.71529H21.0548V21.2021Z"
      fill="#C4C4C4"
    />
    <path d="M7.45374 9.6311H4.42798V12.3237H7.45374V9.6311Z" fill="#C4C4C4" />
    <path d="M11.493 9.6311H8.46655V12.3237H11.493V9.6311Z" fill="#C4C4C4" />
    <path d="M15.5338 9.6311H12.5081V12.3237H15.5338V9.6311Z" fill="#C4C4C4" />
    <path d="M19.5731 9.6311H16.5466V12.3237H19.5731V9.6311Z" fill="#C4C4C4" />
    <path
      d="M7.45374 13.2251H4.42798V15.9157H7.45374V13.2251Z"
      fill="#C4C4C4"
    />
    <path d="M11.493 13.2251H8.46655V15.9157H11.493V13.2251Z" fill="#C4C4C4" />
    <path
      d="M15.5338 13.2251H12.5081V15.9157H15.5338V13.2251Z"
      fill="#C4C4C4"
    />
    <path
      d="M19.5731 13.2251H16.5466V15.9157H19.5731V13.2251Z"
      fill="#C4C4C4"
    />
    <path
      d="M7.45374 16.8179H4.42798V19.5085H7.45374V16.8179Z"
      fill="#C4C4C4"
    />
    <path d="M11.493 16.8179H8.46655V19.5085H11.493V16.8179Z" fill="#C4C4C4" />
    <path
      d="M15.5338 16.8179H12.5081V19.5085H15.5338V16.8179Z"
      fill="#C4C4C4"
    />
    <path
      d="M19.5731 16.8179H16.5466V19.5085H19.5731V16.8179Z"
      fill="#C4C4C4"
    />
  </svg>
);

export const EventTime: React.FC<Props> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" className={props.className || ''}>
    <path
      d="M12.0468 7.02055C7.95633 7.02055 4.64038 10.3365 4.64038 14.4269C4.64038 18.5173 7.95633 21.8333 12.0468 21.8333C16.1372 21.8333 19.4531 18.5173 19.4531 14.4269C19.4531 10.3365 16.1372 7.02055 12.0468 7.02055ZM12.0468 7.02055V3M12.0468 3H15.8553M12.0468 3H8.23735"
      stroke="#C4C4C4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0469 9.98364V14.4275L15.0094 15.9087"
      stroke="#C4C4C4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CouponIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 24 24" className={props.className || ''}>
    <path
      d="M8.68077 5.59008C8.74663 5.94183 9.09557 6.21923 9.50718 6.14227C9.90684 6.05883 10.1341 5.67563 10.0594 5.31539C9.97157 4.89652 9.55785 4.66317 9.16588 4.78008C8.81577 4.88456 8.60868 5.24611 8.68077 5.59008Z"
      fill="#666666"
    />
    <path
      d="M23.8237 15.4136C19.9977 4.27651 20.2609 5.03956 20.2445 5.00164C19.8463 4.07991 19.0732 3.36336 18.1234 3.03565C17.9874 2.98872 10.2863 1.18727 10.0638 1.1102C9.3812 0.873808 8.43289 1.00633 7.76716 1.61862L1.1675 7.69139C0.425542 8.37382 0 9.34528 0 10.3568V21.1107C0 22.378 1.02551 23.409 2.28606 23.409H16.4054C17.666 23.409 18.6915 22.378 18.6915 21.1107V20.0712L22.627 18.387C23.7712 17.8918 24.3035 16.5629 23.8237 15.4136ZM16.4054 22.0027H2.28606C1.80094 22.0027 1.40629 21.6025 1.40629 21.1107V10.3568C1.40629 9.73759 1.66626 9.14329 2.1196 8.72633C7.77381 3.52363 4.27891 6.76878 8.74176 2.65309C8.9745 2.43858 9.29584 2.35242 9.61455 2.44852C9.89942 2.5336 9.39676 2.12418 16.572 8.72642C17.0252 9.14334 17.2852 9.73759 17.2852 10.3568V21.1107C17.2851 21.6025 16.8905 22.0027 16.4054 22.0027ZM22.0711 17.0952L18.6914 18.5416V10.3568C18.6914 9.34528 18.2659 8.37382 17.524 7.69149L12.6091 3.16901L17.6954 4.37588C18.2506 4.57684 18.7031 4.99751 18.9435 5.5364C22.7622 16.6523 22.5046 15.9062 22.5214 15.9447C22.7134 16.3885 22.5102 16.9052 22.0711 17.0952Z"
      fill="#666666"
    />
    <path
      d="M11.3467 9.67995C10.9887 9.52967 10.5766 9.69824 10.4263 10.0563L7.00324 18.2146C6.80795 18.68 7.15291 19.19 7.6513 19.19C7.92604 19.19 8.18705 19.028 8.30002 18.7588L11.7231 10.6004C11.8733 10.2423 11.7048 9.83019 11.3467 9.67995Z"
      fill="#666666"
    />
    <path
      d="M8.046 11.7111C8.046 10.3541 7.05209 9.25 5.83035 9.25C4.60862 9.25 3.61475 10.3541 3.61475 11.7111C3.61475 13.0682 4.60866 14.1723 5.8304 14.1723C7.05213 14.1723 8.046 13.0682 8.046 11.7111ZM5.8304 12.766C5.39168 12.766 5.02103 12.2829 5.02103 11.7111C5.02103 11.1393 5.39164 10.6563 5.8304 10.6563C6.26916 10.6563 6.63976 11.1393 6.63976 11.7111C6.63972 12.2829 6.26911 12.766 5.8304 12.766Z"
      fill="#666666"
    />
    <path
      d="M12.9241 14.833C11.7024 14.833 10.7085 15.9371 10.7085 17.2942C10.7085 18.6512 11.7024 19.7553 12.9241 19.7553C14.1459 19.7553 15.1398 18.6512 15.1398 17.2942C15.1398 15.9371 14.1458 14.833 12.9241 14.833ZM12.9241 18.349C12.4854 18.349 12.1148 17.8659 12.1148 17.2942C12.1148 16.7224 12.4854 16.2393 12.9241 16.2393C13.3629 16.2393 13.7335 16.7224 13.7335 17.2942C13.7335 17.8659 13.3629 18.349 12.9241 18.349Z"
      fill="#666666"
    />
  </svg>
);

export const DocIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 52 52" fill="none" className={props.className || ''}>
    <path
      d="M6.49988 3.12001C6.49988 1.39668 7.89656 0 9.61989 0H32.4999L45.4999 10.92V48.88C45.4999 50.6033 44.1033 52 42.3799 52H9.61989C7.89656 52 6.49988 50.6033 6.49988 48.88V3.12001Z"
      fill="#8BD8BD"
    />
    <path
      d="M32.4999 0V7.79997C32.4999 9.52329 33.8966 10.92 35.6199 10.92H45.5"
      fill="#70BBA1"
    />
    <path
      d="M17.4405 46.2301H15V37.2345H17.2847C19.5954 37.2345 21.8024 37.9743 21.8024 41.6879C21.8024 45.3464 19.6863 46.2301 17.4405 46.2301ZM17.5962 38.7918H17.155V44.6728H17.5962C18.7772 44.6728 19.5688 44.0368 19.5688 41.6866C19.5695 39.2863 18.726 38.7918 17.5962 38.7918Z"
      fill="white"
    />
    <path
      d="M26.0203 46.4508C23.6577 46.4508 22.4111 44.6475 22.4111 41.7268C22.4111 38.871 23.6577 37.0015 26.0203 37.0015C28.383 37.0015 29.6288 38.8061 29.6288 41.7268C29.6288 44.5813 28.383 46.4508 26.0203 46.4508ZM26.0203 38.5712C25.0204 38.5712 24.6187 39.5192 24.6187 41.7261C24.6187 43.9317 25.034 44.8798 26.0203 44.8798C27.0455 44.8798 27.422 43.9064 27.422 41.7261C27.422 39.5193 27.019 38.5712 26.0203 38.5712Z"
      fill="white"
    />
    <path
      d="M36.4018 39.2467C35.9086 38.8444 35.3889 38.5971 34.7017 38.5971C33.4694 38.5971 32.5857 39.5192 32.5857 41.7131C32.5857 43.8681 33.4169 44.7888 34.6505 44.7888C35.5323 44.7888 36.0917 44.4248 36.5971 44.0361L37.5705 45.282C36.9086 45.9179 35.9346 46.4506 34.5071 46.4506C32.0283 46.4506 30.3398 44.8018 30.3398 41.7123C30.3398 38.7001 32.1444 37 34.546 37C35.8438 37 36.6997 37.39 37.4524 38L36.4018 39.2467Z"
      fill="white"
    />
  </svg>
);

export const AttachmentIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 44 44" fill="none" className={props.className || ''}>
    <g clipPath="url(#clip0_564_764)">
      <path
        d="M31.625 28.4167C22.7883 28.4167 15.5833 21.2117 15.5833 12.375C15.5833 7.40667 17.8567 2.95167 21.4317 0H5.04167C2.255 0 0 2.255 0 5.04167V38.9583C0 41.745 2.255 44 5.04167 44H31.625C34.4117 44 36.6667 41.745 36.6667 38.9583V27.61C35.09 28.1233 33.385 28.4167 31.625 28.4167Z"
        fill="#8BD8BD"
      />
      <path
        d="M31.625 24.75C24.8013 24.75 19.25 19.1987 19.25 12.375C19.25 5.55133 24.8013 0 31.625 0C38.4487 0 44 5.55133 44 12.375C44 19.1987 38.4487 24.75 31.625 24.75Z"
        fill="#273773"
      />
      <path
        d="M31.6247 19.25C30.6127 19.25 29.7914 18.4287 29.7914 17.4167V7.33333C29.7914 6.32133 30.6127 5.5 31.6247 5.5C32.6367 5.5 33.458 6.32133 33.458 7.33333V17.4167C33.458 18.4287 32.6367 19.25 31.6247 19.25Z"
        fill="white"
      />
      <path
        d="M36.6667 14.2085H26.5833C25.5713 14.2085 24.75 13.3871 24.75 12.3751C24.75 11.3631 25.5713 10.5418 26.5833 10.5418H36.6667C37.6787 10.5418 38.5 11.3631 38.5 12.3751C38.5 13.3871 37.6787 14.2085 36.6667 14.2085Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_764">
        <rect width="44" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HelpIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 512 512" className={props.className || ''}>
    <g>
      <g>
        <g>
          <path d="M290.211,360.727c-5.234,0.488-10.489-0.693-15.011-3.375c-3.304-3.392-4.888-8.101-4.305-12.8     c0.122-3.912,0.589-7.806,1.396-11.636c0.781-4.394,1.79-8.744,3.025-13.033l13.731-47.244c1.416-4.663,2.352-9.459,2.793-14.313     c0-5.236,0.698-8.844,0.698-10.938c0.292-9.333-3.693-18.289-10.822-24.32c-8.769-6.732-19.689-10.041-30.72-9.309     c-7.905,0.119-15.749,1.413-23.273,3.84c-8.223,2.56-16.873,5.624-25.949,9.193l-3.956,15.36     c2.676-0.931,5.935-1.978,9.658-3.142c3.552-1.052,7.234-1.601,10.938-1.629c5.196-0.563,10.426,0.713,14.778,3.607     c2.956,3.527,4.343,8.109,3.84,12.684c-0.013,3.913-0.442,7.814-1.28,11.636c-0.815,4.073-1.862,8.378-3.142,12.916     l-13.847,47.476c-1.116,4.413-2.009,8.879-2.676,13.382c-0.544,3.855-0.816,7.743-0.815,11.636     c-0.057,9.397,4.24,18.291,11.636,24.087c8.904,6.837,19.98,10.226,31.185,9.542c7.89,0.162,15.753-0.978,23.273-3.375     c6.594-2.25,15.399-5.469,26.415-9.658l3.724-14.662c-2.984,1.238-6.057,2.249-9.193,3.025     C298.346,360.583,294.274,360.935,290.211,360.727z" />
          <path d="M304.756,136.727c-6.333-5.816-14.677-8.945-23.273-8.727c-8.591-0.194-16.927,2.932-23.273,8.727     c-11.632,10.03-12.931,27.591-2.9,39.224c0.894,1.037,1.863,2.006,2.9,2.9c13.252,11.853,33.294,11.853,46.545,0     c11.632-10.129,12.851-27.769,2.722-39.401C306.635,138.481,305.725,137.571,304.756,136.727z" />
          <path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M256,488.727     C127.468,488.727,23.273,384.532,23.273,256S127.468,23.273,256,23.273S488.727,127.468,488.727,256S384.532,488.727,256,488.727     z" />
        </g>
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

export const PropertyManagerIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 24 24" className={props.className || ''}>
    <path
      d="M19.7987 21.9999H3.31696C3.15848 21.9999 3 21.8731 3 21.683V16.8335C3 15.534 3.7607 14.3612 4.96513 13.8224C6.16957 13.2836 7.37401 12.9032 8.54675 12.6497C8.67353 12.618 8.83201 12.6814 8.89541 12.8082L11.5578 18.45L14.2203 12.8399C14.2837 12.7131 14.4105 12.6497 14.5689 12.6814C15.7417 12.9349 16.9461 13.3153 18.1506 13.8541C19.355 14.3929 20.1157 15.5657 20.1157 16.8652V21.7147C20.1157 21.8731 19.9572 21.9999 19.7987 21.9999ZM3.60222 21.3977H19.4818V16.8335C19.4818 15.7876 18.8479 14.805 17.8653 14.3612C16.7876 13.8858 15.71 13.5055 14.664 13.2836L11.8114 19.2424C11.748 19.3375 11.6529 19.4009 11.5262 19.4009C11.3994 19.4009 11.3043 19.3375 11.2409 19.2424L8.38827 13.2836C7.34231 13.5055 6.23296 13.8858 5.18701 14.3612C4.20444 14.805 3.57052 15.7559 3.57052 16.8335V21.3977H3.60222Z"
      fill="#666666"
      stroke="#666666"
      strokeWidth="1"
    />
    <path
      d="M12.2553 14.4871H10.829C10.7022 14.4871 10.5754 14.3921 10.5437 14.2653L10.2268 12.9341C10.1951 12.839 10.2268 12.7439 10.2902 12.6805C10.3536 12.6171 10.4487 12.5537 10.5437 12.5537H12.604C12.6991 12.5537 12.7941 12.5854 12.8575 12.6805C12.9209 12.7439 12.9209 12.839 12.9209 12.9341L12.604 14.2653C12.5406 14.3921 12.4138 14.4871 12.2553 14.4871ZM11.0826 13.8849H12.0334L12.2236 13.1559H10.9241L11.0826 13.8849Z"
      fill="#666666"
      stroke="#666666"
      strokeWidth="1"
    />
    <path
      d="M12.6362 17.1823C12.4777 17.1823 12.3509 17.0555 12.3192 16.897L11.9706 14.2345C11.9389 14.0761 12.0656 13.9176 12.2241 13.8859C12.3826 13.8542 12.5411 13.981 12.5728 14.1395L12.9531 16.8019V16.8336C12.9531 17.0238 12.8263 17.1823 12.6362 17.1823ZM10.4809 17.1823C10.3224 17.1823 10.1639 17.0555 10.1639 16.8653V16.8336L10.5442 14.1712C10.5759 14.0127 10.7344 13.8859 10.8929 13.9176C11.0514 13.9493 11.1782 14.1078 11.1465 14.2662L10.7661 16.9287C10.7661 17.0555 10.6393 17.1823 10.4809 17.1823ZM16.7566 22C16.5981 22 16.4397 21.8732 16.4397 21.683V18.038C16.4397 17.8796 16.5664 17.7211 16.7566 17.7211C16.9151 17.7211 17.0736 17.8479 17.0736 18.038V21.7147C17.0736 21.8732 16.9151 22 16.7566 22ZM6.36041 22C6.20194 22 6.04346 21.8732 6.04346 21.683V18.038C6.04346 17.8796 6.17024 17.7211 6.36041 17.7211C6.51889 17.7211 6.67737 17.8479 6.67737 18.038V21.7147C6.64568 21.8732 6.51889 22 6.36041 22ZM11.5585 11.9842C9.4666 11.9842 7.43807 9.16323 7.43807 6.24723C7.43807 3.67987 9.05455 2 11.5585 2C14.0625 2 15.679 3.64818 15.679 6.24723C15.679 9.16323 13.6504 11.9842 11.5585 11.9842ZM11.5585 2.63391C9.84694 2.63391 8.04029 3.58479 8.04029 6.24723C8.04029 8.78288 9.81525 11.3819 11.5585 11.3819C13.3018 11.3819 15.0767 8.78288 15.0767 6.24723C15.0767 3.58479 13.2701 2.63391 11.5585 2.63391Z"
      fill="#666666"
      stroke="#666666"
      strokeWidth="1"
    />
    <path
      d="M12.7307 6.05666C12.1919 6.05666 11.7165 5.96157 11.3044 5.7397C10.8924 5.54952 10.6071 5.26426 10.4169 5.07409C9.87812 5.67631 8.89555 6.12005 7.72281 5.96157C7.56433 5.92987 7.43755 5.80309 7.46924 5.61292C7.50094 5.45444 7.65942 5.32765 7.8179 5.35935C9.02234 5.51783 9.90982 4.91561 10.1634 4.40848C10.2268 4.31339 10.3219 4.25 10.4486 4.25C10.5754 4.25 10.6705 4.31339 10.7339 4.44017C10.7656 4.53526 11.7482 6.437 15.1396 4.85222C15.2981 4.78883 15.4566 4.85222 15.5517 5.0107C15.615 5.16918 15.5517 5.32765 15.3932 5.42274C14.4106 5.83479 13.5231 6.05666 12.7307 6.05666Z"
      fill="#666666"
      stroke="#666666"
      strokeWidth="1"
    />
  </svg>
);

export const FolderIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" className={props.className || ''}>
    <path
      d="M19.418 5.10938H10.365C10.12 3.90735 9.05457 3 7.78125 3H4.58203C3.7097 3 3 3.7097 3 4.58203V19.418C3 20.2903 3.7097 21 4.58203 21H19.418C20.2903 21 21 20.2903 21 19.418C21 18.2872 21 8.42718 21 6.69141C21 5.81907 20.2903 5.10938 19.418 5.10938ZM4.58203 4.05469H7.78125C8.65358 4.05469 9.36328 4.76439 9.36328 5.63672C9.36328 5.92795 9.59939 6.16406 9.89062 6.16406H19.418C19.7087 6.16406 19.9453 6.40063 19.9453 6.69141V9.32812H18.8906V7.74609C18.8906 7.45486 18.6545 7.21875 18.3633 7.21875H5.63672C5.34548 7.21875 5.10938 7.45486 5.10938 7.74609V9.32812H4.05469V4.58203C4.05469 4.29125 4.29125 4.05469 4.58203 4.05469ZM6.16406 9.32812V8.27344H17.8359V9.32812H6.16406ZM19.9453 19.418C19.9453 19.7087 19.7087 19.9453 19.418 19.9453H4.58203C4.29125 19.9453 4.05469 19.7087 4.05469 19.418V10.3828H19.9453V19.418Z"
      fill="#666666"
      stroke="#666666"
      strokeWidth="0.4"
    />
    <path
      d="M16.5352 14.7422L12.3164 11.5781C12.129 11.4375 11.8711 11.4375 11.6836 11.5781L7.46488 14.7422C7.2319 14.9169 7.18465 15.2475 7.35941 15.4805C7.5341 15.7134 7.86467 15.7607 8.09769 15.5859L8.30863 15.4277V18.3281C8.30863 18.6194 8.54474 18.8555 8.83597 18.8555H10.9453C11.2366 18.8555 11.4727 18.6194 11.4727 18.3281V16.7461H12.5274V18.3281C12.5274 18.6194 12.7635 18.8555 13.0547 18.8555H15.1641C15.4553 18.8555 15.6914 18.6194 15.6914 18.3281V15.4277L15.9024 15.5859C16.1343 15.7599 16.4652 15.7145 16.6407 15.4805C16.8154 15.2475 16.7682 14.9169 16.5352 14.7422ZM14.6368 17.8008H13.5821V16.2188C13.5821 15.9275 13.346 15.6914 13.0547 15.6914H10.9453C10.6541 15.6914 10.418 15.9275 10.418 16.2188V17.8008H9.36331V14.6367L12 12.6592L14.6368 14.6367V17.8008Z"
      fill="#666666"
    />
  </svg>
);

export const CompanyIcon: React.FC<Props> = (props) => (
  <svg viewBox="0 0 20 18" className={props.className || ''}>
    <style type="text/css" />
    <path
      className="st0"
      d="M14.7,15.6c0.4,0.1,0.8,0.3,1.2,0.5c0.5,0.3,0.6,0.6,0.6,1h-2.9v-0.6C14,16.7,14.8,16.4,14.7,15.6L14.7,15.6z   M4.8,15.7c0.2,0.6,1.1,0.7,1.3,0c0.1,0,0.1,0.1,0.2,0.1c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.1,0.4-0.1,0.6c0,0,0,0,0,0l0,0.6h-3  l0-0.4c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.1-0.1,0.2-0.2C3.9,16,4.6,15.9,4.8,15.7L4.8,15.7z M4.6,14.2C4.6,14.2,4.6,14.2,4.6,14.2  c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0.1,0,0.2,0.1,0.2l0.2,0.3C4.9,15,5,15.1,5.1,15.2c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2,0,0.2,0  s0.1-0.1,0.2-0.1C6,15.1,6.1,15,6.2,14.8l0.2-0.4c0-0.1,0.1-0.2,0-0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0l0.1-0.3  c-0.4,0-0.7-0.1-1.1-0.3c-0.1-0.1-0.1-0.2-0.3-0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1-0.1,0.2-0.1,0.2l0.1,0.4  C4.7,14.2,4.7,14.2,4.6,14.2C4.7,14.2,4.7,14.2,4.6,14.2L4.6,14.2z M6.5,14.1C6.5,14.1,6.5,14.1,6.5,14.1c0.1,0,0.1,0.1,0.1,0.1  c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2v0l-0.2,0.4C6.2,15,6.1,15.2,6,15.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0  c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.2-0.3-0.4l-0.2-0.3c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1  c0,0,0,0,0.1,0c0-0.2,0-0.4,0-0.6c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.3,0.4-0.4c0.1,0,0.1-0.1,0.2-0.1C5.5,12.6,6,12.7,6.3,13  c0.1,0.1,0.2,0.3,0.2,0.5L6.5,14.1L6.5,14.1z M8.6,12.6c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.1,0.1,0.2,0.1,0.3l0.3,0.5  C9,13.8,9.1,14,9.3,14.1c0.2,0.2,0.4,0.2,0.6,0.2c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.2c0.2-0.2,0.3-0.4,0.4-0.6l0.3-0.6  c0.1-0.2,0.1-0.3,0.1-0.3c0,0-0.1,0-0.2,0h0c-0.1,0-0.1,0-0.1,0l0.2-0.5c-1.1,0-2-0.7-2.3-0.4c-0.1,0.1-0.1,0.1-0.2,0.2l0.1,0.6  C8.7,12.6,8.7,12.6,8.6,12.6C8.6,12.6,8.6,12.6,8.6,12.6L8.6,12.6z M8.9,14.9c0.4,1.2,1.6,1.2,2,0c0.2,0.2,0.6,0.3,1,0.4  c0.9,0.2,1.2,0.5,1.3,1.5c0,0.1,0,0.2,0,0.4H6.5l0.1-0.7c0-0.3,0.1-0.5,0.2-0.7c0.1-0.1,0.2-0.2,0.3-0.3C7.6,15.3,8.5,15.2,8.9,14.9  L8.9,14.9z M11.4,12.5C11.4,12.5,11.4,12.5,11.4,12.5c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0.1,0,0.3-0.1,0.5v0l-0.4,0.6  c-0.1,0.2-0.3,0.4-0.5,0.6c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.4-0.6  l-0.3-0.5c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0-0.3,0-0.6,0-0.9c0-0.1,0-0.1,0-0.2  c0.1-0.3,0.3-0.5,0.5-0.7c0.1-0.1,0.2-0.1,0.3-0.1c0.6-0.2,1.4-0.1,1.8,0.4c0.2,0.2,0.3,0.5,0.3,0.8L11.4,12.5L11.4,12.5z   M12.4,15.1h0.3h0.2c-0.3-0.8-0.2-1.6,0.5-2.2c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.2,0.4,0.3,0.6,0.5  c0-0.1-0.1-0.3-0.2-0.5c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.2-0.1,0.3h0.4c0.4-0.8,0.1-2.1-0.7-2.6  c-0.2-0.2-0.4-0.2-0.7-0.2c-0.3,0-0.5,0-0.8,0.2c-0.4,0.3-0.7,0.8-0.8,1.4C12.2,14.3,12.2,14.9,12.4,15.1L12.4,15.1z"
    />
    <path
      className="st0"
      d="M19.1,5.6c-0.1-0.1-0.3-0.2-0.4-0.2h-4.3V1.4c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.1-0.1-0.2-0.1s-0.2-0.1-0.3-0.1  H6.2C6.1,0.7,6,0.7,6,0.8c-0.1,0-0.2,0.1-0.2,0.1C5.7,1,5.6,1,5.6,1.1c0,0.1-0.1,0.2-0.1,0.3v4.1H1.3c-0.1,0-0.2,0-0.2,0  C1,5.5,0.9,5.6,0.9,5.6C0.8,5.8,0.7,5.9,0.7,6.1v10.7c0,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2h1.2v-1H1.7V6.5h3.8v5.1  c0,0.1,0.1,0.3,0.1,0.4c0.2,0.2,0.5,0.2,0.7,0c0.1-0.1,0.2-0.2,0.2-0.4V1.7h6.8v9.8c0,0.1,0.1,0.3,0.1,0.4c0.2,0.2,0.5,0.2,0.7,0  c0.1-0.1,0.2-0.2,0.2-0.4V6.5h3.9v9.8h-1.1v1h1.6c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.2,0.1-0.4V6.1C19.3,5.9,19.2,5.8,19.1,5.6z"
    />
    <g>
      <path
        className="st0"
        d="M8.5,4.5H7.2c-0.2,0-0.3-0.1-0.3-0.3V2.9c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C8.8,4.3,8.7,4.5,8.5,4.5z"
      />
      <path
        className="st0"
        d="M10.7,4.5H9.4c-0.2,0-0.3-0.1-0.3-0.3V2.9c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C11,4.3,10.8,4.5,10.7,4.5z"
      />
      <path
        className="st0"
        d="M12.8,4.5h-1.3c-0.2,0-0.3-0.1-0.3-0.3V2.9c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C13.1,4.3,13,4.5,12.8,4.5z"
      />
    </g>
    <g>
      <path
        className="st0"
        d="M8.5,7H7.2C7.1,7,6.9,6.8,6.9,6.7V5.4c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C8.8,6.8,8.7,7,8.5,7z"
      />
      <path
        className="st0"
        d="M10.7,7H9.4C9.2,7,9.1,6.8,9.1,6.7V5.4c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C11,6.8,10.8,7,10.7,7z"
      />
      <path
        className="st0"
        d="M12.8,7h-1.3c-0.2,0-0.3-0.1-0.3-0.3V5.4c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C13.1,6.8,13,7,12.8,7z"
      />
    </g>
    <g>
      <path
        className="st0"
        d="M8.5,9.5H7.2c-0.2,0-0.3-0.1-0.3-0.3V7.9c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C8.8,9.3,8.7,9.5,8.5,9.5z"
      />
      <path
        className="st0"
        d="M10.7,9.5H9.4c-0.2,0-0.3-0.1-0.3-0.3V7.9c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C11,9.3,10.8,9.5,10.7,9.5z"
      />
      <path
        className="st0"
        d="M12.8,9.5h-1.3c-0.2,0-0.3-0.1-0.3-0.3V7.9c0-0.2,0.1-0.3,0.3-0.3h1.3c0.2,0,0.3,0.1,0.3,0.3v1.3   C13.1,9.3,13,9.5,12.8,9.5z"
      />
    </g>
    <path
      className="st0"
      d="M4.8,8.4H2.4c-0.2,0-0.3-0.1-0.3-0.3V7.4c0-0.2,0.1-0.3,0.3-0.3h2.4c0.2,0,0.3,0.1,0.3,0.3v0.7  C5.1,8.3,5,8.4,4.8,8.4z"
    />
    <path
      className="st0"
      d="M4.8,10.4H2.4c-0.2,0-0.3-0.1-0.3-0.3V9.4c0-0.2,0.1-0.3,0.3-0.3h2.4c0.2,0,0.3,0.1,0.3,0.3v0.7  C5.1,10.3,5,10.4,4.8,10.4z"
    />
    <path
      className="st0"
      d="M4.8,12.4H2.4c-0.2,0-0.3-0.1-0.3-0.3v-0.7c0-0.2,0.1-0.3,0.3-0.3h2.4c0.2,0,0.3,0.1,0.3,0.3v0.7  C5.1,12.3,5,12.4,4.8,12.4z"
    />
    <path
      className="st0"
      d="M17.6,8.4h-2.4c-0.2,0-0.3-0.1-0.3-0.3V7.4c0-0.2,0.1-0.3,0.3-0.3h2.4c0.2,0,0.3,0.1,0.3,0.3v0.7  C17.9,8.3,17.7,8.4,17.6,8.4z"
    />
    <path
      className="st0"
      d="M17.6,10.4h-2.4c-0.2,0-0.3-0.1-0.3-0.3V9.4c0-0.2,0.1-0.3,0.3-0.3h2.4c0.2,0,0.3,0.1,0.3,0.3v0.7  C17.9,10.3,17.7,10.4,17.6,10.4z"
    />
    <path
      className="st0"
      d="M17.6,12.4h-2.4c-0.2,0-0.3-0.1-0.3-0.3v-0.7c0-0.2,0.1-0.3,0.3-0.3h2.4c0.2,0,0.3,0.1,0.3,0.3v0.7  C17.9,12.3,17.7,12.4,17.6,12.4z"
    />
  </svg>
);

export const DownLoadImg: React.FC<Props> = (props) => (
  <svg viewBox="0 0 512 512" className={props.className || ''}>
    <g id="Solid">
      <path d="m239.029 384.97a24 24 0 0 0 33.942 0l90.509-90.509a24 24 0 0 0 0-33.941 24 24 0 0 0 -33.941 0l-49.539 49.539v-262.059a24 24 0 0 0 -48 0v262.059l-49.539-49.539a24 24 0 0 0 -33.941 0 24 24 0 0 0 0 33.941z" />
      <path d="m464 232a24 24 0 0 0 -24 24v184h-368v-184a24 24 0 0 0 -48 0v192a40 40 0 0 0 40 40h384a40 40 0 0 0 40-40v-192a24 24 0 0 0 -24-24z" />
    </g>
  </svg>
);
